import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT --------------------------
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";
import { confirmDialog } from "primereact/confirmdialog";

// ------------------ COMPONENTES DE BASE --------------------------------
import Card from "../../../../../../Base/Components/Card/Card";
import { useForm } from "../../../../../../Base/Hooks/useForm";
import Loader from "../../../../../../Base/Components/Loader/Loader";
import { toastShow } from "../../../../../../Base/Services/ToastService";
import AgGrid from "../../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { getDateTimeStringSQL } from "../../../../../../Base/Services/Moment/Luxon";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";
import { ObtenerCurrency } from "../../../../../../Base/API/Global/Currency/CurrencyRequest";
import { ajusteRedondeoEquitativoJson } from "../../../../../../Base/Utils/Funciones/AjusteDiferencialRedondeo";

// ------------------- CONSULTAS A LA API --------------------------------
import { getTiposIngreso, ObtenerSiguienteNoIngreso, } from "../../../../../../API/Suministros/IngresosBodega/IngresosBodegaEncabezadoRequest";
import {
  EditarIngreso,
  EditarIngresoSINPO,
  EliminarItemIngreso,
  EliminarIngreso,
  GuardarIngreso,
  GuardarIngresoSINPO,
  ObtenerDetalleIngresos,
} from "../../../../../../API/Suministros/IngresosBodega/IngresosBodegaDetalleRequest";
import { ObtenerEncabezadoIngresos, VerificarFacturaProveedor, } from "../../../../../../API/Suministros/IngresosBodega/IngresosBodegaEncabezadoRequest";
import { getProveedorAct } from "../../../../../../API/Compras/Proveedores/ProveedoresRequest";
import { getTasaCambio } from "../../../../../../API/CalendarioOperativo/CalendarioOperativoRequest";
import {
  getBandejasActivas,
  getBodegasAct,
  getEstantesAct,
  getPosicionesAct,
} from "../../../../../../API/Suministros/SuministrosRequest";
import { getEstadosCategory } from "../../../../../../API/Global/Status/StatusRequests";
import { getTermTypePaymentTerms } from "../../../../../../API/Compras/Terms/TermsRequest";
import { getCharAccountConcatProveedores } from "../../../../../../API/Finanzas/RegistroContable/RegistroContableRequest";
import { getBalanceOrdenDetalle } from "../../../../../../API/Compras/Ordenes/OrdenesComprasRequests";

// ------------------ COMPONENTES DE NECESARIOS --------------------------
import ModalArchivoPacas from "./ModalArchivoPacas";
import EncabezadoIngresos from "./EncabezadoIngresos";
import LotesOverlayPanel from "../OverlayPanels/LotesOverlayPanel";
import IngresosOverlayPanelDetalle from "../OverlayPanels/IngresosOverlayPanelDetalle";
import { ValidarFacturaProveedor, verificarCAI, } from "../../../../Compras/Proveedores/FuncionesProveedores";
import ProductosOverlayPanel from "../../../../Compras/Requisas/CrudRequisa/OverlayPanels/ProductoOverlayPanel";

const IngresosBodegaCrud = ({
  idIngreso,
  setIngresoToShow = () => {},
  actualizarIngresosScreen = () => {},
  actualizarIngresosScreenListado = () => {},
  habilitar,
  setHabilitar,
  Bodega,
  MateriaPrima,
  Servicios,
  editable = true,
}) => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);

  const [detalles, setDetalles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [proveedor, setProveedor] = useState([]);
  const [selected, setSelected] = useState([]);
  const [term, setTerm] = useState([]);
  const [monedas, setMonedas] = useState([]);

  const [hab, setHab] = useState(false); // HABILITAR BOTON DE COMPONENTE SIN PO
  const [showPOColumn, setShowPOColumn] = useState(true);
  const [bodegas, setBodegas] = useState([]);
  const [estantes, setEstantes] = useState([]);
  const [posicion, setPosicion] = useState([]);
  const [bandeja, setBandeja] = useState([]);

  const [selectedBodega, setSelectedBodega] = useState(null);
  const [selectedEstante, setSelectedEstante] = useState(null);
  const [selectedPosicion, setSelectedPosicion] = useState(null);
  const [selectedBandeja, setSelectedBandeja] = useState(null);
  const [filteredEstantes, setFilteredEstantes] = useState(estantes);
  const [filteredPosiciones, setFilteredPosiciones] = useState(posicion);
  const [filteredBandejas, setFilteredBandejas] = useState(bandeja);
  const [resBand, setResBand] = useState(false);
  const [resPos, setResPos] = useState(false);
  const [resEst, setResEst] = useState(false);

  const [poParaAbrir, setPoParaAbrir] = useState(null);
  const [checkDollar, setCheckDollar] = useState(false);
  const [tiposIngreso, setTiposIngreso] = useState([]);

  const verCostos = userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(49) || userAuth.IdRol === 1;
  const hiddenPriceColumn =
    Number(userAuth?.IdRol) === 1 ||
    String(userAuth?.AccessWeb || "")
      .split(",")
      .map((e) => parseInt(e))
      .includes(29) ||
    (!showPOColumn &&
      String(userAuth?.AccessWeb || "")
        .split(",")
        .map((e) => parseInt(e))
        .includes(39));

  const [verCostosBodega, setVerCostosBodega] = useState(false);
  const [isMateriaPrima, setIsMateriaPrima] = useState(false);
  const [listEstados, setListEstados] = useState([]);
  const [cuentas, setCuentas] = useState([]);
  const ingresoSinOC = userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(39) || userAuth.IdRol === 1;
  const [showModalPacas, setShowModalPacas] = useState(false);
  const [detallePacas, setDetallePacas] = useState(null);

  const initialValues = {
    FechaIngreso: new Date(),
    UsuarioIngreso: userAuth.Usuario,
    IdEstado: 23,
    StatusName: "Ingresado",
    IdIngreso: -1,
    NumeroIngreso: idIngreso ? idIngreso : "",
    FechaFactura: new Date(),
    FechaVencimiento: null,

    IdTipoIngreso: Bodega ? 1 : MateriaPrima ? 2 : 3,
    Inventario: Bodega
      ? "Materiales"
      : MateriaPrima
        ? "Materia Prima"
        : "Servicios",

    TasaCambio: null,
    MontoL: 0,
    MontoD: 0,
    CostoL: 0,
    CostoD: 0,

    Factura: "",
    Comentarios: "",

    CustomerName: "",
    IdVendor: null,
    IdCountry: null,
    IdTerm: null,
    Term: "",

    Moneda: null,
    IdCurrency: 2,
    Currency: "",

    IdPurchaseOrder: null,
    PurchaseOrder: "",

    NombreSucursal: "",
    IdProveedorCAI: null,
    OCE: null,
  };

  const { values, setValues, handleInputChange, resetForm } = useForm(initialValues);

  const idTipoIngresoActual = Number(values?.IdTipoIngreso?.IdTipoIngreso ?? values?.IdTipoIngreso);

  const esMateriaPrimaIngreso =
    MateriaPrima === true ||
    Number(MateriaPrima) === 1 ||
    isMateriaPrima === true ||
    Number(isMateriaPrima) === 1 ||
    idTipoIngresoActual === 2 ||
    values?.Inventario === "Materia Prima";

  const getInfo = async () => {
    setLoading(true);
    setIsMateriaPrima(MateriaPrima);

    const supplier = await getProveedorAct();
    setProveedor(supplier);

    const termTempo = await getTermTypePaymentTerms();
    setTerm(termTempo);

    const bodegasTempo = await getBodegasAct();
    setBodegas(bodegasTempo);

    const estantesTempo = await getEstantesAct();
    setEstantes(estantesTempo);

    const posicionesTempo = await getPosicionesAct();
    setPosicion(posicionesTempo);

    const bandejasTempo = await getBandejasActivas();
    setBandeja(bandejasTempo);

    const tiposIngresoTempo = await getTiposIngreso();
    setTiposIngreso(tiposIngresoTempo);

    const estadosTempo = await getEstadosCategory("Ingreso Bodega Finanzas");
    setListEstados(Array.isArray(estadosTempo) ? estadosTempo : []);

    const cuentasTempo = await getCharAccountConcatProveedores();
    setCuentas(cuentasTempo);

    const monedasTempo = await ObtenerCurrency();
    setMonedas(Array.isArray(monedasTempo) ? monedasTempo : []);

    setLoading(false);
  };

  const getInfoNew = async () => {
    setLoading(true);

    let IdTipoIngreso;
    let Inventario;

    if (Bodega) {
      IdTipoIngreso = 1;
      Inventario = "Materiales";
    } else if (MateriaPrima) {
      IdTipoIngreso = 2;
      Inventario = "Materia Prima";
    } else {
      IdTipoIngreso = 3;
      Inventario = "Servicios";
    }

    const DatosEncabezado = {
      IdTipoIngreso: IdTipoIngreso,
    };

    const NIngreso = await ObtenerSiguienteNoIngreso(DatosEncabezado);
    const calendarioMensual = await getTasaCambio();

    const d = {
      ...initialValues,
      IdIngreso: -100,
      NumeroIngreso: NIngreso[0]?.NumeroIngreso,
      FechaIngreso: new Date(),
      FechaFactura: new Date(),

      IdEstado: 23,
      StatusName: "Ingresado",

      TasaCambio: calendarioMensual[0]?.TasaCambio,
      IdTipoIngreso: IdTipoIngreso,
      Inventario: Inventario,

      IdBodega: null,
      NombreBodega: "",

      CustomerName: "",
      IdVendor: null,
      IdCountry: null,
      IdTerm: null,
      Term: "",

      IdPurchaseOrder: null,
      PurchaseOrder: "",

      Factura: "",
      Comentarios: "",
      NombreSucursal: "",
      IdProveedorCAI: null,
      OCE: null,

      Embalaje: null,
      Desaduanaje: null,
      Flete: null,
      OtrosCostos: null,

      IdEstadoRevisado: IdTipoIngreso === 3 ? 80 : 78,
    };

    setValues(d);
    setLoading(false);
  };

  const obtenerIngreso = async (ingreso) => {
    setLoading(true);

    let req = ingreso ? ingreso : values;

    const detallesTempo = await ObtenerDetalleIngresos(req.NumeroIngreso);
    const detallesConCantidadOriginal = detallesTempo.map((detalle) => ({
      ...detalle,
      IngresoOriginal: Number(detalle?.Ingreso || 0),
      CantidadReservadaOriginal: Number(detalle?.CantidadReservada || 0),
    }));
    setDetalles(detallesConCantidadOriginal);

    const calendarioMensual = await getTasaCambio();
    setHab(true);
    const t = await ObtenerEncabezadoIngresos(req.NumeroIngreso);

    if (t.length > 0) {
      const [detailIngresos] = t;
      // RECUPERAR MONEDA PARA INGRESOS ANTIGUOS
      const idCurrencyCargado =
        Number(
          detailIngresos?.IdCurrency || detallesTempo?.[0]?.IdCurrency || 0,
        ) || null;
      const currencyCargada =
        detailIngresos?.Currency || detallesTempo?.[0]?.Currency || "";
      // RECUPERAR TIPO DE INGRESO
      const idTipoIngresoCargado =
        Number(
          detailIngresos?.IdTipoIngreso ||
            detallesTempo?.[0]?.IdTipoIngreso ||
            0,
        ) || (Bodega ? 1 : MateriaPrima ? 2 : Servicios ? 3 : null);
      const inventarioCargado =
        idTipoIngresoCargado === 1
          ? "Materiales"
          : idTipoIngresoCargado === 2
            ? "Materia Prima"
            : idTipoIngresoCargado === 3
              ? "Servicios"
              : "";

      const n = {
        ...detailIngresos,
        FechaIngreso: new Date(detailIngresos.FechaIngreso),
        FechaFactura: new Date(detailIngresos?.FechaFactura),
        OCE: detailIngresos?.OCE,
        IdCurrency: idCurrencyCargado,
        Currency: currencyCargada,
        IdTipoIngreso: idTipoIngresoCargado,
        Inventario: inventarioCargado,
      };
      setCheckDollar(
        detailIngresos?.IdCurrency
          ? Number(detailIngresos.IdCurrency) === 1
          : Boolean(detailIngresos?.IsDollar),
      );
      setIsMateriaPrima(detailIngresos?.IsMateriaPrima);
      setValues(n);
      setIngresoToShow(detailIngresos.NumeroIngreso);
      setHabilitar(false);

      if (!n?.IdPurchaseOrder) {
        setShowPOColumn(false);
      } else {
        setShowPOColumn(true);
      }
    } else {
      const d = {
        ...initialValues,
        NumeroIngreso: values.NumeroIngreso,
        Factura: null,
        Comentarios: null,
        TasaCambio: calendarioMensual[0]?.TasaCambio,
        OCE: null,
      };
      setValues(d);
      setDetalles([]);
      toastShow(toast, "error", "Error", "No se encontro el Ingreso.");
      setHab(false);
      setHabilitar(true);
    }
    setLoading(false);
  };

  const agregarNuevaFila = () => {
    let newRowData = [...detalles];
    let IdDet = -(detalles?.length + 1);

    const newData = {
      IdIngresoDetalle: IdDet,
      IdPurchaseOrderDetail: null,
      FechaIngreso: new Date(),
      IdEstado: 23,
      StatusName: "Ingresado",
      PurchaseOrder: "",
      NombreProducto: "",
      NombreTipoProducto: "",
      IdProduct: null,
      IdVendor: null,
      IdBodega: null,
      IdEstante: null,
      IdPosicion: null,
      IdSubCategory: null,
      IdTipoIngreso: null,
      IdUnit: null,
      IdUserEdit: null,
      Usuario: "",
      UserName: "",
      NombreCategoria: "",
      NombreSubcategoria: "",
      NombreBodega: "",
      NombreEstante: "",
      NombrePosicion: "",
      FechaCierre: "",
      Precio: 0,
      Ingreso: 0,
      IngresoPacas: 0,
      CustomerName: "",
      Quantity: 0,
      QtyReceive: 0,
      SubTotal: 0,
      Total: 0,
      ISV: 0,
      Descuento: 0,
      TipoProducto: "",
      UnitName: "",
      Inventario: 0,
      Descripcion: "",
      PrecioL: 0,
      MontoL: 0,
      PrecioD: 0,
      MontoD: 0,
      TasaCambio: values.TasaCambio,
      CostoL: 0,
      CostoD: 0,
      IdBandeja: null,
      NombreBandeja: "",
      EmbalajeL: 0,
      EmbalajeD: 0,
      DesaduanajeL: 0,
      DesaduanajeD: 0,
      FleteL: 0,
      FleteD: 0,
      OtrosCostosL: 0,
      OtrosCostosD: 0,
      IdLote: null,
      NoLote: "",
      NoLoteInt: "",

      Currency: values?.Currency || "",
      TAX: 0,
      IdCategory: 0,
      IdCurrency: values?.IdCurrency || null,
    };

    if (newRowData.length > 0) {
      const lastRow = newRowData[newRowData.length - 1];
      if (lastRow && (lastRow.IdPurchaseOrderDetail || lastRow.IdProduct)) {
        newRowData.push(newData);
      } else {
        newRowData[newRowData.length - 1] = newData;
      }
    } else {
      newRowData.push(newData);
    }

    setDetalles(newRowData);
  };

  const actualizarIngresos = async (NoIngreso) => {
    setLoading(true);
    const d = await ObtenerDetalleIngresos(
      NoIngreso ? NoIngreso : values.NumeroIngreso,
    );
    setDetalles(d);
    setLoading(false);
  };

  const changePO = ({ data }) => {
    let selectProveedor = values.CustomerName?.IdVendor;
    return (
      <IngresosOverlayPanelDetalle
        isMateriaPrima={isMateriaPrima}
        selectProveedor={selectProveedor}
        IdProveedor={
          values.IdProveedor ? values?.IdProveedor : values?.IdVendor
        }
        rowData={data}
        onChange={({ api, data }, rowData) => {
          const index = detalles.findIndex(
            (detail) => detail.IdIngresoDetalle === rowData.IdIngresoDetalle,
          );
          const isAlreadyAdded = detalles.some(
            (detail) =>
              detail.IdPurchaseOrderDetail === data.IdPurchaseOrderDetail,
          );
          const isPurchaseOrderDifferent =
            detalles.length === 0 ||
            detalles.every(
              (detail) =>
                !detail.PurchaseOrder ||
                detail.PurchaseOrder === data.PurchaseOrder,
            );

          if (isAlreadyAdded) {
            toastShow(
              toast,
              "warn",
              "Advertencia",
              "El detalle de orden de compra seleccionada ya esta agregada en este ingreso",
            );
            return;
          }

          if (!isPurchaseOrderDifferent) {
            toastShow(
              toast,
              "warn",
              "Advertencia",
              "No se permite agregar detalles de diferentes ordenes de compras.",
            );
            return; // Detener la ejecución si el PurchaseOrder es diferente
          }

          let newDetail = [...detalles];
          newDetail[index].PurchaseOrder = data.PurchaseOrder;
          newDetail[index].IdPurchaseOrderDetail = data.IdPurchaseOrderDetail;
          newDetail[index].IdCategory = data.IdCategoria;
          newDetail[index].CodigoProducto = data.CodigoProducto;
          newDetail[index].IdSubCategory = data.IdSubCategoria;
          newDetail[index].IdTipoProducto = data.IdTipoProducto;
          newDetail[index].IdTipoIngreso = data.IdType;
          newDetail[index].IdCurrency = data.IdCurrency;
          newDetail[index].UnitPrice = data.UnitPrice;
          newDetail[index].Discount = data.Discount;
          newDetail[index].Descripcion = data.Description;
          newDetail[index].IdProduct = data.IdComponent;
          newDetail[index].NombreProducto = data.NombreProducto;
          newDetail[index].NombreTipoProducto = data.NombreTipoProducto;
          newDetail[index].IdVendor = null;
          newDetail[index].CustomerName = null;
          newDetail[index].NombreCategoria = data.NombreCategoria;
          newDetail[index].NombreSubcategoria = data.NombreSubcategoria;
          newDetail[index].IdUnit = data.IdUnit;
          newDetail[index].UnitName = data.UnitSimbol;
          newDetail[index].Type = data.Type;
          newDetail[index].IdBodega = data.IdBodega;
          newDetail[index].NombreBodega = data.NombreBodega;
          newDetail[index].IdEstante = data.IdEstante;
          newDetail[index].NombreEstante = data.NombreEstante;
          newDetail[index].IdPosicion = data.IdPosicion;
          newDetail[index].NombrePosicion = data.NombrePosicion;
          newDetail[index].IdBandeja = data.IdBandeja;
          newDetail[index].NombreBandeja = data.NombreBandeja;
          newDetail[index].Currency = data.Currency;
          newDetail[index].UserName = data.UserNameAgente;
          newDetail[index].Usuario = data.Usuario;
          newDetail[index].Quantity = data.Quantity;
          newDetail[index].QtyReceive = data.QtyReceive;
          newDetail[index].ISV = data.TAX;
          newDetail[index].Precio =
            data?.IdCurrency === 1
              ? data?.UnitPrice * values?.TasaCambio
              : data?.UnitPrice;
          newDetail[index].PrecioD =
            data?.IdCurrency === 1
              ? data?.UnitPrice
              : data?.UnitPrice / values?.TasaCambio;
          newDetail[index].Balance = data?.Quantity - data?.QtyReceive;
          newDetail[index].ISVProducto = data?.TAX / data?.Quantity;
          newDetail[index].ISVProductoL = 0;
          newDetail[index].DescuentoProducto = data?.Discount / data?.Quantity;
          newDetail[index].EmbalajeL = 0;
          newDetail[index].EmbalajeD = 0;
          newDetail[index].DesaduanajeL = 0;
          newDetail[index].DesaduanajeD = 0;
          newDetail[index].FleteL = 0;
          newDetail[index].FleteD = 0;
          newDetail[index].OtrosCostosL = 0;
          newDetail[index].OtrosCostosD = 0;
          newDetail[index].NoSacos = 0;

          setSelectedBandeja(data);
          setSelectedPosicion(data);
          setSelectedEstante(data);
          setSelectedBodega(data);

          setDetalles(newDetail);
          api.stopEditing();
        }}
      />
    );
  };

  // ASIGNAR TOTALES DE LOS DETALLES AL ENCABEZADO
  const asignarMontosEncabezado = (listaDetalles = []) => {
    const montoL = Number(
      listaDetalles
        .reduce((total, detalle) => total + Number(detalle?.MontoL || 0), 0)
        .toFixed(2),
    );

    const montoD = Number(
      listaDetalles
        .reduce((total, detalle) => total + Number(detalle?.MontoD || 0), 0)
        .toFixed(2),
    );

    const costoL = Number(
      listaDetalles
        .reduce((total, detalle) => total + Number(detalle?.CostoL || 0), 0)
        .toFixed(2),
    );

    const costoD = Number(
      listaDetalles
        .reduce((total, detalle) => total + Number(detalle?.CostoD || 0), 0)
        .toFixed(2),
    );

    setValues((prevValues) => ({
      ...prevValues,

      MontoL: montoL,
      MontoD: montoD,
      CostoL: costoL,
      CostoD: costoD,
    }));
  };

  const changeProducto = ({ data }) => {
    return (
      <ProductosOverlayPanel
        MateriaPrima={MateriaPrima}
        rowData={data}
        onChange={({ api, data }, rowData) => {
          const index = detalles.findIndex(
            (detail) => detail.IdIngresoDetalle === rowData.IdIngresoDetalle,
          );

          const isAlreadyAdded = detalles.some(
            (detail) => detail.IdProduct === data.IdProduct,
          );

          if (isAlreadyAdded) {
            toastShow(
              toast,
              "warn",
              "Advertencia",
              "Ya existe el producto en este ingreso",
            );
            return;
          }

          let newDetail = [...detalles];
          newDetail[index].IdCategory = data.IdCategoria;
          newDetail[index].CodigoProducto = data.CodigoProducto;
          newDetail[index].IdSubCategory = data.IdSubCategoria;
          newDetail[index].IdTipoProducto = data.IdTipoProducto;
          newDetail[index].IdTipoIngreso = data.IdType;
          newDetail[index].IdCurrency = values?.IdCurrency;
          newDetail[index].UnitPrice = data.UnitPrice;
          newDetail[index].Discount = data.Discount;
          newDetail[index].Descripcion = data.DescripcionProducto;
          newDetail[index].IdProduct = data.IdProduct;
          newDetail[index].NombreProducto = data.NombreProducto;
          newDetail[index].NombreTipoProducto = data.NombreTipoProducto;
          newDetail[index].IdVendor = null;
          newDetail[index].CustomerName = null;
          newDetail[index].NombreCategoria = data.NombreCategoria;
          newDetail[index].NombreSubcategoria = data.NombreSubcategoria;
          newDetail[index].IdUnit = data.IdUnit;
          newDetail[index].UnitName = data.UnitSimbol;
          newDetail[index].IdBodega = data.IdBodega;
          newDetail[index].NombreBodega = data.NombreBodega;
          newDetail[index].IdEstante = data.IdEstante;
          newDetail[index].NombreEstante = data.NombreEstante;
          newDetail[index].IdPosicion = data.IdPosicion;
          newDetail[index].NombrePosicion = data.NombrePosicion;
          newDetail[index].IdBandeja = data.IdBandeja;
          newDetail[index].NombreBandeja = data.NombreBandeja;
          newDetail[index].Currency = values?.Currency;
          newDetail[index].Quantity = data.Quantity;
          newDetail[index].QtyReceive = data.QtyReceive;
          newDetail[index].Price = 0;
          newDetail[index].ISVProductoL = 0;
          newDetail[index].Descuento = 0;
          newDetail[index].MontoL = 0;
          newDetail[index].MontoD = 0;
          newDetail[index].DescuentoD = 0;
          newDetail[index].EmbalajeL = 0;
          newDetail[index].EmbalajeD = 0;
          newDetail[index].DesaduanajeL = 0;
          newDetail[index].DesaduanajeD = 0;
          newDetail[index].FleteL = 0;
          newDetail[index].FleteD = 0;
          newDetail[index].OtrosCostosL = 0;
          newDetail[index].OtrosCostosD = 0;

          setSelectedBandeja(data);
          setSelectedPosicion(data);
          setSelectedEstante(data);
          setSelectedBodega(data);

          setDetalles(newDetail);
          api.stopEditing();
        }}
      />
    );
  };

  // FUNCION PARA AGREGAR DETALLES DE ORDEN DE COMPRA AL INGRESO
  const addOC = (infoOrden) => {
    const allPurchaseOrders = new Set([
      ...detalles.map((item) => item.PurchaseOrder),
      ...infoOrden.map((item) => item.PurchaseOrder),
    ]);

    if (allPurchaseOrders.size > 1) {
      toastShow(
        toast,
        "error",
        "Error",
        "No se permiten detalles de órdenes diferentes.",
      );
      return;
    }

    const OrdenExistente = detalles.some((i) =>
      infoOrden.some(
        (f) =>
          f.IdIngreso === i.IdDetalleRef && f.PurchaseOrder === i.PurchaseOrder,
      ),
    );

    if (OrdenExistente) {
      toastShow(toast, "error", "Error", "No se permiten valores repetidos.");
    } else {
      let dataNueva = [];

      infoOrden.forEach((f) => {
        let Id = (detalles.length + dataNueva.length + 1) * -1;
        let Precio =
          f.IdCurrency === 1 ? f.UnitPrice * values?.TasaCambio : f.UnitPrice;
        let PrecioD =
          f.IdCurrency === 1 ? f.UnitPrice : f.UnitPrice / values?.TasaCambio;

        let ISVProducto = f?.TAX / f?.Quantity;
        let ISV18Producto = f?.ISV18 / f?.Quantity;
        let DescuentoProducto = f?.Discount / f?.Quantity;

        dataNueva.push({
          IdIngresoDetalle: Id,
          PurchaseOrder: f.PurchaseOrder,
          IdPurchaseOrderDetail: f.IdPurchaseOrderDetail,
          IdProduct: f.IdComponent,
          IdCategory: f.IdCategoria,
          IdSubCategory: f.IdSubCategoria,
          IdTipoProducto: f.IdTipoProducto,
          IdTipoIngreso: f.IdType,
          IdCurrency: f.IdCurrency,
          Descripcion: f.Description,
          NombreProducto: f.NombreProducto,
          NombreTipoProducto: f.NombreTipoProducto,
          NombreCategoria: f.NombreCategoria,
          NombreSubcategoria: f.NombreSubcategoria,
          IdUnit: f.IdUnit,
          UnitName: f.UnitSimbol,
          Type: f.Type,
          IdBodega: f.IdBodega,
          NombreBodega: f.NombreBodega,
          IdEstante: f.IdEstante,
          NombreEstante: f.NombreEstante,
          IdPosicion: f.IdPosicion,
          NombrePosicion: f.NombrePosicion,
          Currency: f.Currency,
          UserName: f.UserNameAgente,
          Usuario: f.Usuario,
          Quantity: f.Quantity,
          QtyReceive: f.QtyReceive,
          Precio,
          PrecioD,
          ISV: f.TAX,
          ISV18Producto,
          Ingreso: esMateriaPrimaIngreso
            ? 0
            : Servicios
              ? 0
              : f.Balance,

          Balance: Servicios ? 0 : f.Balance,
          CantidadReservada: Servicios ? f.BalanceReservado : 0,
          BalanceReservado: Servicios ? f.BalanceReservado : 0,
          FechaIngreso: new Date(),
          IdEstado: 23,
          StatusName: "Ingresado",
          TasaCambio: values.TasaCambio,
          CodigoProducto: f.CodigoProducto,
          IdBandeja: f.IdBandeja,
          NombreBandeja: f.NombreBandeja,
          ISVProducto,
          DescuentoProducto,
          NoSacos: 0,
        });
      });

      let nuevoArreglo = [...detalles, ...dataNueva];

      nuevoArreglo = nuevoArreglo.map((data) => {
        const cantidad = Servicios
          ? Number(data?.CantidadReservada || 0)
          : Number(data?.Ingreso || 0);
        const tasaCambio = Number(data?.TasaCambio || values?.TasaCambio || 1);
        const precioL = Number(data?.Precio || 0);
        const precioD = Number(data?.PrecioD || 0);
        const isvProducto = Number(data?.ISVProducto || 0);
        const isv18Producto = Number(data?.ISV18Producto || 0);
        const descuentoProducto = Number(data?.DescuentoProducto || 0);

        // Precio ya viene convertido en Lempiras.
        const SubTotal = precioL * cantidad;
        const SubTotalD = precioD * cantidad;
        const ISVProductoL =
          data?.IdCurrency === 1
            ? isvProducto * tasaCambio * cantidad
            : isvProducto * cantidad;
        const ISVProductoD =
          data?.IdCurrency === 1
            ? isvProducto * cantidad
            : (isvProducto / tasaCambio) * cantidad;
        const ISV18ProductoL =
          data?.IdCurrency === 1
            ? isv18Producto * tasaCambio * cantidad
            : isv18Producto * cantidad;
        const ISV18ProductoD =
          data?.IdCurrency === 1
            ? isv18Producto * cantidad
            : (isv18Producto / tasaCambio) * cantidad;

        const Descuento =
          data?.IdCurrency === 1
            ? descuentoProducto * tasaCambio * cantidad
            : descuentoProducto * cantidad;
        const DescuentoD =
          data?.IdCurrency === 1
            ? descuentoProducto * cantidad
            : (descuentoProducto / tasaCambio) * cantidad;
        const MontoL = SubTotal + ISVProductoL + ISV18ProductoL - Descuento;
        const MontoD = SubTotalD + ISVProductoD + ISV18ProductoD - DescuentoD;
        const CostoL = MontoL - ISVProductoL - ISV18ProductoL;
        const CostoD = MontoD - ISVProductoD - ISV18ProductoD;

        return {
          ...data,
          SubTotal,
          SubTotalD,
          ISVProductoL,
          ISVProductoD,
          ISV18ProductoL,
          ISV18ProductoD,
          Descuento,
          DescuentoD,
          MontoL,
          MontoD,
          CostoL,
          CostoD,
        };
      });

      const camposRedondeo = [
        "MontoL",
        "MontoD",
        "CostoL",
        "CostoD",
        "ISVProductoL",
        "ISVProductoD",
      ];
      nuevoArreglo = ajusteRedondeoEquitativoJson(nuevoArreglo, camposRedondeo);

      setDetalles(nuevoArreglo);
      asignarMontosEncabezado(nuevoArreglo);
      setSelectedBandeja(nuevoArreglo);
      setSelectedPosicion(nuevoArreglo);
      setSelectedEstante(nuevoArreglo);
      setSelectedBodega(nuevoArreglo);
    }
  };

  const addSingleOC = (infoOrden) => {
    let IdOrdenDetailQueViene = infoOrden.data?.IdPurchaseOrderDetail;
    let encuentraIdEnDetalles = detalles.find(
      (i) => i?.IdPurchaseOrderDetail === IdOrdenDetailQueViene,
    );

    if (!infoOrden || infoOrden.length === 0) return;

    if (encuentraIdEnDetalles) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "La orden que desea agregar ya existe en este ingreso.",
      );
      return;
    }

    const detalle = infoOrden?.data;
    let Id = (detalles.length + 1) * -1;
    let Precio =
      detalle.IdCurrency === 1
        ? detalle.UnitPrice * values?.TasaCambio
        : detalle.UnitPrice;
    let PrecioD =
      detalle.IdCurrency === 1
        ? detalle.UnitPrice
        : detalle.UnitPrice / values?.TasaCambio;
    let ISVProducto = detalle?.TAX / detalle?.Quantity;
    let ISV18Producto = detalle?.ISV18 / detalle?.Quantity;

    let DescuentoProducto = detalle?.Discount / detalle?.Quantity;

    let nuevoDetalle = {
      IdIngresoDetalle: Id,
      PurchaseOrder: detalle.PurchaseOrder,
      IdPurchaseOrderDetail: detalle.IdPurchaseOrderDetail,
      IdProduct: detalle.IdComponent,
      IdCategory: detalle.IdCategoria,
      IdSubCategory: detalle.IdSubCategoria,
      IdTipoProducto: detalle.IdTipoProducto,
      IdTipoIngreso: detalle.IdType,
      IdCurrency: detalle.IdCurrency,
      Descripcion: detalle.Description,
      NombreProducto: detalle.NombreProducto,
      NombreTipoProducto: detalle.NombreTipoProducto,
      NombreCategoria: detalle.NombreCategoria,
      NombreSubcategoria: detalle.NombreSubcategoria,
      IdUnit: detalle.IdUnit,
      UnitName: detalle.UnitSimbol,
      Type: detalle.Type,
      IdBodega: detalle.IdBodega,
      NombreBodega: detalle.NombreBodega,
      IdEstante: detalle.IdEstante,
      NombreEstante: detalle.NombreEstante,
      IdPosicion: detalle.IdPosicion,
      NombrePosicion: detalle.NombrePosicion,
      Currency: detalle.Currency,
      UserName: detalle.UserNameAgente,
      Usuario: detalle.Usuario,
      Quantity: detalle.Quantity,
      QtyReceive: detalle.QtyReceive,
      Precio,
      PrecioD,
      ISV: detalle.TAX,
      Ingreso: esMateriaPrimaIngreso
        ? 0
        : Servicios
          ? 0
          : detalle.Balance,
      Balance: Servicios ? 0 : detalle.Balance,
      CantidadReservada: Servicios ? detalle.BalanceReservado : 0,
      BalanceReservado: Servicios ? detalle.BalanceReservado : 0,
      FechaIngreso: new Date(),
      IdEstado: 23,
      StatusName: "Ingresado",
      TasaCambio: values.TasaCambio,
      CodigoProducto: detalle.CodigoProducto,
      IdBandeja: detalle.IdBandeja,
      NombreBandeja: detalle.NombreBandeja,
      ISVProducto,
      ISV18Producto,
      DescuentoProducto,
      NoSacos: 0,
    };

    // Cálculos adicionales
    const cantidad = Servicios
      ? Number(nuevoDetalle?.CantidadReservada || 0)
      : Number(nuevoDetalle?.Ingreso || 0);
    const tasaCambio = Number(
      nuevoDetalle?.TasaCambio || values?.TasaCambio || 1,
    );
    const precioL = Number(nuevoDetalle?.Precio || 0);
    const precioD = Number(nuevoDetalle?.PrecioD || 0);
    const isvProducto = Number(nuevoDetalle?.ISVProducto || 0);
    const isv18Producto = Number(nuevoDetalle?.ISV18Producto || 0);
    const descuentoProducto = Number(nuevoDetalle?.DescuentoProducto || 0);

    const SubTotal = precioL * cantidad;
    const SubTotalD = precioD * cantidad;

    const ISVProductoL =
      nuevoDetalle?.IdCurrency === 1
        ? isvProducto * tasaCambio * cantidad
        : isvProducto * cantidad;
    const ISVProductoD =
      nuevoDetalle?.IdCurrency === 1
        ? isvProducto * cantidad
        : (isvProducto / tasaCambio) * cantidad;
    const ISV18ProductoL =
      nuevoDetalle?.IdCurrency === 1
        ? isv18Producto * tasaCambio * cantidad
        : isv18Producto * cantidad;
    const ISV18ProductoD =
      nuevoDetalle?.IdCurrency === 1
        ? isv18Producto * cantidad
        : (isv18Producto / tasaCambio) * cantidad;
    const Descuento =
      nuevoDetalle?.IdCurrency === 1
        ? descuentoProducto * tasaCambio * cantidad
        : descuentoProducto * cantidad;
    const DescuentoD =
      nuevoDetalle?.IdCurrency === 1
        ? descuentoProducto * cantidad
        : (descuentoProducto / tasaCambio) * cantidad;

    const MontoL = SubTotal + ISVProductoL + ISV18ProductoL - Descuento;
    const MontoD = SubTotalD + ISVProductoD + ISV18ProductoD - DescuentoD;
    const CostoL = MontoL - ISVProductoL - ISV18ProductoL;
    const CostoD = MontoD - ISVProductoD - ISV18ProductoD;

    nuevoDetalle = {
      ...nuevoDetalle,
      SubTotal,
      SubTotalD,
      ISVProductoL,
      ISVProductoD,
      ISV18ProductoL,
      ISV18ProductoD,
      Descuento,
      DescuentoD,
      MontoL,
      MontoD,
      CostoL,
      CostoD,
    };

    let nuevoArreglo = [...detalles, nuevoDetalle];
    const camposRedondeo = [
      "MontoL",
      "MontoD",
      "CostoL",
      "CostoD",
      "ISVProductoL",
      "ISVProductoD",
    ];
    nuevoArreglo = ajusteRedondeoEquitativoJson(nuevoArreglo, camposRedondeo);

    setDetalles(nuevoArreglo);
    asignarMontosEncabezado(nuevoArreglo);
    setSelectedBandeja(nuevoArreglo);
    setSelectedPosicion(nuevoArreglo);
    setSelectedEstante(nuevoArreglo);
    setSelectedBodega(nuevoArreglo);
  };

  // VALIDAR CAI Y FACTURA ANTES DE GUARDAR
  const validarFacturaAntesDeGuardar = async () => {
    const idVendorActual = values?.CustomerName?.IdVendor || values?.IdVendor;

    //Buscar el proveedor real para recuperar el país cuando la información viene desde una PO.
    const proveedorActual = proveedor.find(
      (item) => Number(item?.IdVendor) === Number(idVendorActual),
    );
    const idCountryActual = Number(
      values?.CustomerName?.IdCountry ||
        values?.IdCountry ||
        proveedorActual?.IdCountry ||
        0,
    );

    if (idCountryActual !== 95) {
      return {
        valido: true,
        IdProveedorCAI: null,
        NombreSucursal: "",
      };
    }

    const facturaActual = String(values?.Factura || "").trim();

    if (facturaActual.length !== 19) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "La factura no tiene un formato válido para validar el CAI.",
      );

      return {
        valido: false,
        IdProveedorCAI: null,
        NombreSucursal: "",
      };
    }

    if (values?.IdProveedorCAI) {
      const resultadoCAI = await verificarCAI({
        IdProveedorCAI: values.IdProveedorCAI,

        Factura: facturaActual,

        FechaFactura: values.FechaFactura,
      });

      if (!resultadoCAI?.valido) {
        toastShow(
          toast,
          "warn",
          "Advertencia",
          resultadoCAI?.msj || "La factura no corresponde al CAI seleccionado.",
        );

        return {
          valido: false,
          IdProveedorCAI: null,
          NombreSucursal: "",
        };
      }

      return {
        valido: true,

        IdProveedorCAI: values.IdProveedorCAI,

        NombreSucursal:
          typeof values?.NombreSucursal === "object"
            ? values?.NombreSucursal?.NombreSucursal || ""
            : values?.NombreSucursal || "",
      };
    }

    const resultadoFactura = await ValidarFacturaProveedor({
      ...values,

      IdVendor: idVendorActual,

      IdProveedorCAI: null,

      Factura: facturaActual,
    });

    const caiDetectado = resultadoFactura?.Valores || {};

    if (!resultadoFactura?.Valido || !caiDetectado?.IdProveedorCAI) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        resultadoFactura?.Mensaje ||
          "La factura no pertenece a ningún CAI válido del proveedor.",
      );

      return {
        valido: false,
        IdProveedorCAI: null,
        NombreSucursal: "",
      };
    }

    // Mostrar el CAI detectado automáticamente.
    setValues((prevValues) => ({
      ...prevValues,

      IdProveedorCAI: caiDetectado.IdProveedorCAI,

      NombreSucursal: caiDetectado.NombreSucursal || "",
    }));

    return {
      valido: true,
      IdProveedorCAI: caiDetectado.IdProveedorCAI,
      NombreSucursal: caiDetectado.NombreSucursal || "",
    };
  };

  // CONFIRMAR SI SE DESEA CONTINUAR CON UNA FACTURA REPETIDA
  const confirmarFacturaRepetida = async () => {
    const idVendorActual = values?.CustomerName?.IdVendor || values?.IdVendor;

    const facturaActual = String(values?.Factura || "").trim();

    if (!idVendorActual || !facturaActual) {
      return {
        continuar: true,
        permitirDuplicada: false,
      };
    }

    const facturasEncontradas = await VerificarFacturaProveedor({
      IdVendor: idVendorActual,
      Factura: facturaActual,

      IdIngreso: Number(values?.IdIngreso) > 0 ? Number(values.IdIngreso) : 0,
    });

    // Si la API falló, no continuamos silenciosamente.
    if (!Array.isArray(facturasEncontradas)) {
      toastShow(
        toast,
        "error",
        "Error",
        "No fue posible validar si la factura ya existe.",
      );

      return {
        continuar: false,
        permitirDuplicada: false,
      };
    }

    // FACTURAS DEL MISMO PROVEEDOR
    const facturasMismoProveedor = facturasEncontradas.filter(
      (ingreso) => Number(ingreso?.IdVendor) === Number(idVendorActual),
    );

    // FACTURAS DE OTROS PROVEEDORES
    const facturasOtrosProveedores = facturasEncontradas.filter(
      (ingreso) => Number(ingreso?.IdVendor) !== Number(idVendorActual),
    );
    /*
      CASO 1:
      MISMO PROVEEDOR + MISMA FACTURA

      Se muestra únicamente advertencia
      y NO se permite guardar.
    */
    if (facturasMismoProveedor.length > 0) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Esta factura ya existe para el proveedor seleccionado.",
      );

      return {
        continuar: false,
        permitirDuplicada: false,
      };
    }

    /*
      CASO 2:
      LA FACTURA NO EXISTE EN NINGÚN OTRO INGRESO.
    */
    if (facturasOtrosProveedores.length === 0) {
      return {
        continuar: true,
        permitirDuplicada: false,
      };
    }

    /*
      CASO 3:
      MISMA FACTURA PERO OTRO PROVEEDOR.

      Mostramos el Dialog y dejamos decidir
      al usuario si desea continuar.
    */
    const mensaje = (
      <div style={{ width: "32vw" }}>
        <h5>
          Existen otros ingresos con el mismo número de factura, pero con otro
          proveedor.
        </h5>

        {facturasOtrosProveedores.map((ingreso) => (
          <div className="pt-3" key={ingreso.IdIngreso}>
            <span className="fw-bold">Proveedor:</span> {ingreso.CustomerName}
            <br />
            <span className="fw-bold">Factura:</span> {ingreso.Factura}
            <br />
            <span className="fw-bold">No. Ingreso:</span>{" "}
            {ingreso.NumeroIngreso}
            <br />
            <span className="fw-bold">Fecha Factura:</span>{" "}
            {ingreso.FechaFactura
              ? new Date(ingreso.FechaFactura).toLocaleDateString()
              : ""}
            <br />
            <span className="fw-bold">Fecha Ingreso:</span>{" "}
            {ingreso.FechaIngreso
              ? new Date(ingreso.FechaIngreso).toLocaleDateString()
              : ""}
          </div>
        ))}

        <h6 className="fw-bold pt-4">
          ¿Desea continuar con el mismo número de factura?
        </h6>
      </div>
    );

    return await new Promise((resolve) => {
      confirmDialog({
        message: mensaje,

        header: "Factura repetida",

        icon: "pi pi-exclamation-triangle",

        acceptLabel: "Sí, continuar",

        rejectLabel: "No",

        accept: () => {
          resolve({
            continuar: true,

            /*
                No necesitamos saltarnos la validación
                de mismo proveedor del SP porque realmente
                es otro proveedor.
              */
            permitirDuplicada: false,
          });
        },

        reject: () => {
          resolve({
            continuar: false,
            permitirDuplicada: false,
          });
        },

        style: {
          backgroundColor: "white",
        },
      });
    });
  };

  // VALIDAR OCE ANTES DE GUARDAR
  const validarOCEAntesDeGuardar = () => {
    const idCountryActual = Number(
      values?.CustomerName?.IdCountry ?? values?.IdCountry ?? 0,
    );
    if (idCountryActual !== 95) {
      return true;
    }

    const esDetalleExento = (detalle) =>
      detalle?.IsExento === true || Number(detalle?.IsExento) === 1;

    const tieneDetalleNoExento = detalles.some(
      (detalle) => !esDetalleExento(detalle),
    );

    const todosSonExentos =
      detalles.length > 0 &&
      detalles.every((detalle) => esDetalleExento(detalle));

    const tieneISV = detalles.some(
      (detalle) =>
        Number(detalle?.ISVProductoL || 0) > 0 ||
        Number(detalle?.ISV18ProductoL || 0) > 0,
    );

    const oceIngresada = String(values?.OCE || "").trim();
    if (!tieneISV && tieneDetalleNoExento && !oceIngresada) {
      toastShow(
        toast,
        "error",
        "Error",
        "Debe ingresar la OCE correspondiente a la factura.",
      );

      return false;
    }

    if (tieneISV && todosSonExentos && oceIngresada) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "No es necesario ingresar la OCE si todos los productos son exentos.",
      );

      return false;
    }

    if (oceIngresada) {
      const formatoOCE = /^OC\d{4}\d{6}$/;
      if (!formatoOCE.test(oceIngresada)) {
        toastShow(
          toast,
          "error",
          "Error",
          "El OCE debe tener formato OCYYYY000000 (12 caracteres).",
        );

        return false;
      }
    }
    return true;
  };

  const obtenerIdTipoIngresoActual = () => {
    if (Bodega) return 1;
    if (MateriaPrima) return 2;
    if (Servicios) return 3;

    return values?.IdTipoIngreso || values?.Inventario?.IdTipoIngreso || null;
  };

  // VALIDAR COSTOS DEL ENCABEZADO CONTRA LOS DETALLES
  const validarCostosAntesDeGuardar = () => {
    const costoLDetalles = Number(
      detalles
        .reduce((total, detalle) => total + Number(detalle?.CostoL || 0), 0)
        .toFixed(2),
    );
    const costoDDetalles = Number(
      detalles
        .reduce((total, detalle) => total + Number(detalle?.CostoD || 0), 0)
        .toFixed(2),
    );
    const costoLEncabezado = Number(Number(values?.CostoL || 0).toFixed(2));
    const costoDEncabezado = Number(Number(values?.CostoD || 0).toFixed(2));

    if (
      costoLEncabezado !== costoLDetalles ||
      costoDEncabezado !== costoDDetalles
    ) {
      toastShow(
        toast,
        "error",
        "Error",
        "El costo de la factura no coincide con la suma de los costos de los detalles.",
      );

      return false;
    }
    return true;
  };

  // VALIDAR QUE TODOS LOS DETALLES TENGAN PRODUCTO
  const validarProductosAntesDeGuardar = () => {
    const detalleSinProducto = detalles.find(
      (detalle) => !detalle?.IdProduct || Number(detalle?.IdProduct) <= 0,
    );

    if (detalleSinProducto) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Debe seleccionar un producto en todos los detalles.",
      );

      return false;
    }

    return true;
  };

  // GUARDAR INGRESOS
  const guardarIngresos = async () => {
    const productosValidos = validarProductosAntesDeGuardar();
    if (!productosValidos) {
      return;
    }

    const validacionFactura = await validarFacturaAntesDeGuardar();
    if (!validacionFactura?.valido) {
      return;
    }

    const validacionDuplicado = await confirmarFacturaRepetida();
    if (!validacionDuplicado?.continuar) {
      return;
    }

    const oceValida = validarOCEAntesDeGuardar();
    if (!oceValida) {
      return;
    }

    const costosValidos = validarCostosAntesDeGuardar();
    if (!costosValidos) {
      return;
    }

    const IdTipoIngresoActual = obtenerIdTipoIngresoActual();
    let guardar = true;

    if (detalles.length === 0) {
      toastShow(
        toast,
        "error",
        "Error al guardar",
        "Debe seleccionar al menos una orden de compra.",
      );
      guardar = false;
    } else {
      detalles.forEach((d) => {
        if (d.PurchaseOrder === "" || d.IdPurchaseOrderDetail === 0) {
          toastShow(
            toast,
            "error",
            "Error al guardar",
            "Todos los items deben contener una orden de compra.",
          );
          guardar = false;
        }
      });
    }

    if (guardar) {
      setLoading(true);

      const encabezado = {
        IdIngreso: values.IdIngreso,
        NumeroIngreso: values.NumeroIngreso,
        IdVendor: values.CustomerName?.IdVendor || values?.IdVendor,
        IdUserIngreso: userAuth.IdUser,
        FechaIngreso: getDateTimeStringSQL(new Date(values.FechaIngreso)),
        Factura: values.Factura,
        PermitirFacturaDuplicada: validacionDuplicado?.permitirDuplicada
          ? 1
          : 0,
        IdUsuarioEdit: userAuth.IdUser,
        Comentarios: values.Comentarios,
        IdEstado: values.IdEstado,
        TasaCambio: values.TasaCambio,
        IdTerm: values?.Term?.IdTerm ? values?.Term?.IdTerm : values?.IdTerm,
        FechaFactura: getDateTimeStringSQL(values.FechaFactura),
        IdProveedorCAI:
          validacionFactura?.IdProveedorCAI ||
          values?.NombreSucursal?.IdProveedorCAI ||
          values?.IdProveedorCAI ||
          null,
        IdTipoIngreso: IdTipoIngresoActual,
        IdPurchaseOrder: values?.IdPurchaseOrder,
        Embalaje: values?.Embalaje,
        Desaduanaje: values?.Desaduanaje,
        Flete: values?.Flete,
        OtrosCostos: values?.OtrosCostos,
        TasaCambioEmbalaje: values?.TasaCambioEmbalaje,
        TasaCambioDesaduanaje: values?.TasaCambioDesaduanaje,
        TasaCambioFlete: values?.TasaCambioFlete,
        TasaCambioOtrosCostos: values?.TasaCambioOtrosCostos,
        IsDollar: checkDollar === true ? 1 : 0,
        IsMateriaPrima: isMateriaPrima === true ? 1 : 0,
        OCE: values?.OCE,
        IdEstadoRevisado:
          values?.IdEstadoRevisado || (IdTipoIngresoActual === 3 ? 80 : 78),
        IdCuenta: values?.IdAccount || values?.IdCuenta,
        IdCurrency: values?.IdCurrency || detalles?.[0]?.IdCurrency || null,
        MontoL: Number(values?.MontoL || 0),
        MontoD: Number(values?.MontoD || 0),
        CostoL: Number(values?.CostoL || 0),
        CostoD: Number(values?.CostoD || 0),
      };

      const detallesIngreso = detalles.map((detalle) => {
        return {
          ...detalle[0],
          IdIngresoDetalle: detalle.IdIngresoDetalle,
          IdIngreso: values.IdIngreso,
          IdPurchaseOrderDetail: detalle.IdPurchaseOrderDetail,
          IdProduct: detalle.IdProduct,
          IdCategory: detalle.IdCategory,
          IdSubCategory: detalle.IdSubCategory,
          IdTipoProducto: detalle.IdTipoProducto,
          IdEstado: detalle.IdEstado,
          Descripcion: detalle.Descripcion,
          IdTipoIngreso: IdTipoIngresoActual,
          IdCurrency: detalle.IdCurrency,
          IdUnit: detalle.IdUnit,
          IdEstante: detalle.IdEstante,
          IdPosicion: detalle.IdPosicion,
          FechaCierre: detalle.FechaCierre,
          IdUsuarioEdit: userAuth.IdUser,
          Ingreso: detalle.Ingreso,
          CantidadReservada: detalle.CantidadReservada,
          IdBodega: detalle?.IdBodega,
          IdBandeja: detalle?.IdBandeja,
          Precio: detalle.Precio,
          ISV: detalle.ISV,
          TasaCambio: values.TasaCambio,
          ISVProducto: detalle?.ISVProducto,
          DescuentoProducto: detalle?.DescuentoProducto,
          Total: detalle?.Total,
          ISVProductoL: detalle?.ISVProductoL,
          ISVProductoD: detalle?.ISVProductoD,
          ISV18ProductoL: detalle?.ISV18ProductoL,
          ISV18ProductoD: detalle?.ISV18ProductoD,
          Descuento: detalle?.Descuento,
          DescuentoD: detalle?.DescuentoD,
          SubTotal: detalle?.SubTotal,
          SubTotalD: detalle?.SubTotalD,
          MontoL: detalle?.MontoL,
          MontoD: detalle?.MontoD,
          CostoL: detalle?.CostoL,
          CostoD: detalle?.CostoD,
          EmbalajeL: detalle?.EmbalajeL,
          EmbalajeD: detalle?.EmbalajeD,
          DesaduanajeL: detalle?.DesaduanajeL,
          DesaduanajeD: detalle?.DesaduanajeD,
          FleteL: detalle?.FleteL,
          FleteD: detalle?.FleteD,
          OtrosCostosL: detalle?.OtrosCostosL,
          OtrosCostosD: detalle?.OtrosCostosD,
          PrecioUL: detalle?.PrecioUL,
          PrecioUD: detalle?.PrecioUD,
          IdLote: detalle?.IdLote,
          NoSacos: detalle?.NoSacos,
          FechaObsoleto: detalle?.FechaObsoleto,
          IsExento: detalle?.IsExento,
        };
      });
      setLoading(false);

      if (encabezado.IdIngreso > 0) {
        const respuestaDetalles = await EditarIngreso(
          encabezado,
          detallesIngreso,
        );
        if (respuestaDetalles[0].ESTADO !== -1) {
          setHabilitar(false);
          toastShow(toast, "success", "Editada", respuestaDetalles[0]?.MENSAJE);
          actualizarIngresos();
          actualizarIngresosScreen();
          actualizarIngresosScreenListado();
          obtenerIngreso();
          setLoading(false);
        } else {
          toastShow(
            toast,
            "error",
            "Error al editar",
            respuestaDetalles[0]?.MENSAJE,
          );
          setLoading(false);
        }
      } else {
        const respuestaDetalles = await GuardarIngreso(
          encabezado,
          detallesIngreso,
        );
        if (respuestaDetalles[0].ESTADO !== -1) {
          setHabilitar(false);
          toastShow(
            toast,
            "success",
            "Guardado",
            respuestaDetalles[0]?.MENSAJE,
          );
          actualizarIngresos(respuestaDetalles[0]);
          obtenerIngreso(respuestaDetalles[0]);
          actualizarIngresosScreen();
          actualizarIngresosScreenListado();
          obtenerIngreso();
          setLoading(false);
        } else {
          toastShow(
            toast,
            "error",
            "Error al guardar",
            respuestaDetalles[0]?.MENSAJE,
          );
          setLoading(false);
        }
      }
    } else {
      setLoading(false);
    }
  };

  // GUARDAR INGRESOS SIN ORDEN DE COMPRA
  const guardarIngresosBodega = async () => {
    const productosValidos = validarProductosAntesDeGuardar();
    if (!productosValidos) {
      return;
    }
    const validacionFactura = await validarFacturaAntesDeGuardar();
    if (!validacionFactura?.valido) {
      return;
    }

    const validacionDuplicado = await confirmarFacturaRepetida();
    if (!validacionDuplicado?.continuar) {
      return;
    }

    const oceValida = validarOCEAntesDeGuardar();
    if (!oceValida) {
      return;
    }

    const costosValidos = validarCostosAntesDeGuardar();
    if (!costosValidos) {
      return;
    }

    const IdTipoIngresoActual = obtenerIdTipoIngresoActual();

    // SIN PO
    let guardar = true;
    if (detalles.length === 0) {
      toastShow(
        toast,
        "error",
        "Error al guardar",
        "Debe seleccionar al menos una orden de compra.",
      );
      guardar = false;
    } else {
      detalles.forEach((d) => {
        if (!esMateriaPrimaIngreso && Number(d.Ingreso || 0) === 0) {
          toastShow(
            toast,
            "error",
            "Error al guardar",
            "La cantidad debe ser mayor a 0.",
          );
          guardar = false;
        }
      });
    }

    if (guardar) {
      setLoading(true);
      setHabilitar(true);

      const encabezado = {
        IdIngreso: values.IdIngreso,
        NumeroIngreso: values.NumeroIngreso,
        IdVendor: values.CustomerName?.IdVendor || values?.IdVendor,
        IdUserIngreso: userAuth.IdUser,
        FechaIngreso: getDateTimeStringSQL(new Date(values.FechaIngreso)),
        Factura: values.Factura,
        PermitirFacturaDuplicada: validacionDuplicado?.permitirDuplicada
          ? 1
          : 0,
        IdUsuarioEdit: userAuth.IdUser,
        Comentarios: values.Comentarios,
        IdEstado: values.IdEstado,
        TasaCambio: values.TasaCambio,
        IdTerm: values?.Term?.IdTerm ? values?.Term?.IdTerm : values?.IdTerm,
        FechaFactura: getDateTimeStringSQL(values?.FechaFactura),
        IdProveedorCAI:
          validacionFactura?.IdProveedorCAI ||
          values?.NombreSucursal?.IdProveedorCAI ||
          values?.IdProveedorCAI ||
          null,

        IdTipoIngreso: IdTipoIngresoActual,
        IdPurchaseOrder: null,

        Embalaje: values?.Embalaje,
        Desaduanaje: values?.Desaduanaje,
        Flete: values?.Flete,
        OtrosCostos: values?.OtrosCostos,

        TasaCambioEmbalaje: values?.TasaCambioEmbalaje,
        TasaCambioDesaduanaje: values?.TasaCambioDesaduanaje,
        TasaCambioFlete: values?.TasaCambioFlete,
        TasaCambioOtrosCostos: values?.TasaCambioOtrosCostos,
        IsDollar: checkDollar === true ? 1 : 0,
        IsMateriaPrima: isMateriaPrima === true ? 1 : 0,
        OCE: values?.OCE,
        IdEstadoRevisado:
          values?.IdEstadoRevisado || (IdTipoIngresoActual === 3 ? 80 : 78),
        IdCuenta: values?.IdAccount || values?.IdCuenta,
        IdCurrency: values?.IdCurrency || detalles?.[0]?.IdCurrency || null,
        MontoL: Number(values?.MontoL || 0),
        MontoD: Number(values?.MontoD || 0),
        CostoL: Number(values?.CostoL || 0),
        CostoD: Number(values?.CostoD || 0),
      };

      const detallesIngreso = detalles.map((detalle) => {
        return {
          ...detalle[0],
          IdIngresoDetalle: detalle.IdIngresoDetalle,
          IdIngreso: values.IdIngreso,
          // IdPurchaseOrderDetail: null,
          IdProduct: detalle.IdProduct,
          IdCategory: detalle.IdCategory,
          IdSubCategory: detalle.IdSubCategory,
          IdTipoProducto: detalle.IdTipoProducto,
          IdEstado: detalle.IdEstado,
          FechaIngreso: getDateTimeStringSQL(new Date(values.FechaIngreso)),
          Descripcion: detalle.Descripcion,
          IdTipoIngreso: IdTipoIngresoActual,
          IdCurrency: detalle.IdCurrency,
          IdUnit: detalle.IdUnit,
          IdEstante: detalle.IdEstante,
          IdPosicion: detalle.IdPosicion,
          // FechaCierre: detalle.FechaCierre,
          IdUsuarioEdit: userAuth.IdUser,
          Ingreso: detalle.Ingreso,
          Precio: detalle.Precio,
          ISV: detalle.ISV,
          TasaCambio: values.TasaCambio,
          IdBodega: detalle?.IdBodega,
          IdBandeja: detalle?.IdBandeja,

          ISVProductoL: detalle?.ISVProductoL,
          ISVProductoD: detalle?.ISVProductoD,

          ISV18ProductoL: detalle?.ISV18ProductoL,
          ISV18ProductoD: detalle?.ISV18ProductoD,

          Descuento: detalle?.Descuento,
          DescuentoD: detalle?.DescuentoD,
          SubTotal: detalle?.SubTotal,
          SubTotalD: detalle?.SubTotalD,

          MontoL: detalle?.MontoL,
          MontoD: detalle?.MontoD,

          CostoL: detalle?.CostoL,
          CostoD: detalle?.CostoD,

          EmbalajeL: detalle?.EmbalajeL,
          EmbalajeD: detalle?.EmbalajeD,
          DesaduanajeL: detalle?.DesaduanajeL,
          DesaduanajeD: detalle?.DesaduanajeD,
          FleteL: detalle?.FleteL,
          FleteD: detalle?.FleteD,
          OtrosCostosL: detalle?.OtrosCostosL,
          OtrosCostosD: detalle?.OtrosCostosD,

          PrecioUL: detalle?.PrecioUL,
          PrecioUD: detalle?.PrecioUD,
          IdLote: detalle?.IdLote,
          NoSacos: detalle?.NoSacos,
          FechaObsoleto: detalle?.FechaObsoleto,
          IsExento: detalle?.IsExento || false,
          CantidadReservada: detalle?.CantidadReservada || 0,
        };
      });

      if (encabezado?.IdIngreso > 0) {
        const respuestaDetalles = await EditarIngresoSINPO(
          encabezado,
          detallesIngreso,
        );
        if (respuestaDetalles[0].ESTADO !== -1) {
          setHabilitar(false);
          toastShow(toast, "success", "Editada", respuestaDetalles[0]?.MENSAJE);
          actualizarIngresos();
          actualizarIngresosScreen();
          actualizarIngresosScreenListado();
          obtenerIngreso();
          setLoading(false);
        } else {
          toastShow(
            toast,
            "error",
            "Error al editar",
            respuestaDetalles[0]?.MENSAJE,
          );
          setLoading(false);
        }
      } else {
        const respuestaDetalles = await GuardarIngresoSINPO(
          encabezado,
          detallesIngreso,
        );
        if (respuestaDetalles[0].ESTADO !== -1) {
          setHabilitar(false);
          toastShow(toast, "success", "Guardado", respuestaDetalles[0].MENSAJE);
          actualizarIngresos(respuestaDetalles[0]);
          obtenerIngreso(respuestaDetalles[0]);
          actualizarIngresosScreen();
          actualizarIngresosScreenListado();
          obtenerIngreso();
          setLoading(false);
        } else {
          toastShow(
            toast,
            "error",
            "Error al guardar",
            respuestaDetalles[0]?.MENSAJE,
          );
          setLoading(false);
        }
      }
    } else {
      setLoading(false);
    }
  };

  // ELIMINAR INGRESO COMPLETO
  const eliminarIngresoCompleto = () => {
    if (!values?.IdIngreso || Number(values.IdIngreso) <= 0) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Debe cargar un ingreso guardado.",
      );
      return;
    }

    const algunDetalleConSalida = detalles.some(
      (detalle) =>
        detalle?.Inventario < detalle?.Ingreso && detalle?.IdIngresoDetalle > 0,
    );
    if (algunDetalleConSalida) {
      toastShow(
        toast,
        "error",
        "Error",
        "No se puede eliminar el ingreso porque uno o más productos ya tienen salidas.",
      );
      return;
    }

    if (Number(values?.IdEstado) === 26) {
      toastShow(toast, "warn", "Advertencia", "El ingreso ya está eliminado.");
      return;
    }

    confirmDialog({
      message: "¿Está seguro que desea eliminar todo este ingreso?",
      header: "Eliminar ingreso",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sí",
      rejectLabel: "No",

      accept: async () => {
        const response = await EliminarIngreso(
          { ...values, IdUsuarioEdit: userAuth.IdUser },
          detalles,
        );

        if (response?.[0]?.ESTADO === 1) {
          toastShow(toast, "success", "Eliminado", response[0]?.MENSAJE);

          setHabilitar(false);

          actualizarIngresosScreen();
          actualizarIngresosScreenListado();

          setIngresoToShow(null);
          setDetalles([]);
        } else {
          toastShow(toast, "error", "Error", response?.[0]?.MENSAJE);
        }
      },

      style: {
        backgroundColor: "white",
      },
    });
  };

  // ELIMINAR ITEM
  const eliminarItemDetalle = () => {
    if (selected.length > 0) {
      const algunDetalleNoValido = selected.some(
        (detalle) =>
          detalle?.Inventario < detalle?.Ingreso &&
          detalle?.IdIngresoDetalle > 0,
      );
      if (algunDetalleNoValido) {
        toastShow(
          toast,
          "error",
          "Error",
          "No se puede eliminar, ya existe una salida de este ingreso.",
        );
      } else {
        confirmDialog({
          message: "Esta seguro que desea eliminar este item",
          header: "Cancelar",
          icon: "pi pi-exclamation-triangle",
          acceptLabel: "Si",
          accept: () => cancelarDetalle(),
          rejectLabel: "No",
          style: { backgroundColor: "white" },
        });
      }
    } else {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Seleccione un detalle de ingreso.",
      );
    }
  };

  const cancelarDetalle = async () => {
    const detallesPersistidos = selected.filter(
      (detalle) => Number(detalle?.IdIngresoDetalle) > 0,
    );
    const detallesRestantes = detalles.filter(
      (detalle) =>
        !selected.some(
          (seleccionado) =>
            seleccionado.IdIngresoDetalle === detalle.IdIngresoDetalle,
        ),
    );

    if (detallesPersistidos.length > 0) {
      const result = await EliminarItemIngreso(
        {
          ...values,
          IdUsuarioEdit: userAuth.IdUser,
        },
        detallesPersistidos,
      );

      if (result?.[0]?.ESTADO !== 1) {
        toastShow(
          toast,
          "error",
          "Error",
          result?.[0]?.MENSAJE || "No fue posible eliminar los detalles.",
        );
        return;
      }
    }

    setDetalles(detallesRestantes);
    asignarMontosEncabezado(detallesRestantes);

    actualizarIngresosScreen();
    actualizarIngresosScreenListado();

    setSelected([]);
  };

  const changeIngreso = async ({ data, oldValue, column }) => {
    const index = detalles.findIndex(
      (detail) => detail.IdIngresoDetalle === data.IdIngresoDetalle,
    );
    if (index === -1) {
      return;
    }

    const newDetail = [...detalles];
    const cantidadNueva = Number(
      Servicios ? data?.CantidadReservada || 0 : data?.Ingreso || 0,
    );
    const cantidadAnterior = Number(oldValue || 0);

    // VALIDAR CANTIDAD CONTRA LA PO
    if (showPOColumn && data?.IdPurchaseOrderDetail) {
      const balancePO = await getBalanceOrdenDetalle(
        data.IdPurchaseOrderDetail,
      );

      if (Array.isArray(balancePO) && balancePO.length > 0) {
        const infoPO = balancePO[0];

        const balanceActual = Number(infoPO?.Balance || 0);

        const cantidadOriginal =
          Number(data?.IdIngresoDetalle) > 0
            ? Number(
                Servicios
                  ? data?.CantidadReservadaOriginal || 0
                  : data?.IngresoOriginal || 0,
              )
            : 0;

        /*
          Si este ingreso ya existía, su cantidad
          original se suma nuevamente al balance.
            
          Ejemplo:
          Balance BD = 15
          Este ingreso originalmente tenía = 5
            
          Puede editarse hasta:
          15 + 5 = 20
        */
        const cantidadMaxima = balanceActual + cantidadOriginal;

        if (cantidadNueva > cantidadMaxima) {
          toastShow(
            toast,
            "warn",
            "Advertencia",
            `La cantidad ingresada supera el balance disponible de la Orden de Compra. Máximo permitido: ${cantidadMaxima}.`,
          );

          if (Servicios) {
            newDetail[index].CantidadReservada = cantidadAnterior;
          } else {
            newDetail[index].Ingreso = cantidadAnterior;
          }

          setDetalles(newDetail);

          return;
        }

        const balanceRestante = Math.max(cantidadMaxima - cantidadNueva, 0);

        if (Servicios) {
          newDetail[index].CantidadReservada = cantidadNueva;

          newDetail[index].BalanceReservado = balanceRestante;
        } else {
          newDetail[index].Ingreso = cantidadNueva;

          newDetail[index].Balance = balanceRestante;
        }
      }
    } else {
      // INGRESO SIN PO
      if (Servicios) {
        newDetail[index].CantidadReservada = cantidadNueva;

        newDetail[index].Ingreso = cantidadNueva;
      } else {
        newDetail[index].Ingreso = cantidadNueva;
      }
    }

    // RECALCULAR VALORES FINANCIEROS
    const tasaCambio = Number(data?.TasaCambio || values?.TasaCambio || 1);
    const idCurrency = Number(data?.IdCurrency);
    const precioL = Number(data?.Precio || 0);
    const precioD = Number(
      data?.PrecioD || (tasaCambio > 0 ? precioL / tasaCambio : 0),
    );

    const cantidad = cantidadNueva;
    const subTotalL = precioL * cantidad;
    const subTotalD = precioD * cantidad;

    let isvL = 0;
    let isvD = 0;

    let isv18L = 0;
    let isv18D = 0;

    let descuentoL = 0;
    let descuentoD = 0;

    /*
      CON PO:
      ISVProducto, ISV18Producto y
      DescuentoProducto son valores unitarios
      provenientes de la PO.
    */
    if (showPOColumn) {
      const isvProducto = Number(data?.ISVProducto || 0);
      const isv18Producto = Number(data?.ISV18Producto || 0);
      const descuentoProducto = Number(data?.DescuentoProducto || 0);

      isvL =
        idCurrency === 1
          ? isvProducto * tasaCambio * cantidad
          : isvProducto * cantidad;

      isvD =
        idCurrency === 1
          ? isvProducto * cantidad
          : (isvProducto / tasaCambio) * cantidad;

      isv18L =
        idCurrency === 1
          ? isv18Producto * tasaCambio * cantidad
          : isv18Producto * cantidad;

      isv18D =
        idCurrency === 1
          ? isv18Producto * cantidad
          : (isv18Producto / tasaCambio) * cantidad;

      descuentoL =
        idCurrency === 1
          ? descuentoProducto * tasaCambio * cantidad
          : descuentoProducto * cantidad;

      descuentoD =
        idCurrency === 1
          ? descuentoProducto * cantidad
          : (descuentoProducto / tasaCambio) * cantidad;
    } else {
      /*
        SIN PO:
        estos valores pueden ser ingresados
        manualmente en CSM.
      */
      isvL = Number(data?.ISVProductoL || 0);
      isv18L = Number(data?.ISV18ProductoL || 0);
      descuentoL = Number(data?.Descuento || 0);

      isvD = tasaCambio > 0 ? isvL / tasaCambio : 0;

      isv18D = tasaCambio > 0 ? isv18L / tasaCambio : 0;

      descuentoD = tasaCambio > 0 ? descuentoL / tasaCambio : 0;
    }

    const montoL = subTotalL + isvL + isv18L - descuentoL;

    const montoD = subTotalD + isvD + isv18D - descuentoD;

    newDetail[index] = {
      ...newDetail[index],

      SubTotal: subTotalL,
      SubTotalD: subTotalD,

      ISVProductoL: isvL,
      ISVProductoD: isvD,

      ISV18ProductoL: isv18L,
      ISV18ProductoD: isv18D,

      Descuento: descuentoL,
      DescuentoD: descuentoD,

      MontoL: montoL,
      MontoD: montoD,

      CostoL: montoL - isvL - isv18L,
      CostoD: montoD - isvD - isv18D,

      TasaCambio: tasaCambio,
    };

    setDetalles(newDetail);
    asignarMontosEncabezado(newDetail);
  };

  const changePrecio = ({ data, oldValue, column }) => {
    const index = detalles.findIndex(
      (detail) => detail.IdIngresoDetalle === data.IdIngresoDetalle,
    );
    if (index === -1) {
      return;
    }

    let newDetail = [...detalles];
    if (!data.CodigoProducto) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Agregue el producto a ingresar.",
      );

      newDetail[index] = {
        ...newDetail[index],
        SubTotal: 0,
        SubTotalD: 0,
        Descuento: 0,
        DescuentoD: 0,
        ISVProductoL: 0,
        ISVProductoD: 0,
        ISV18ProductoL: 0,
        ISV18ProductoD: 0,
        MontoL: 0,
        MontoD: 0,
        CostoL: 0,
        CostoD: 0,
        Precio: 0,
        PrecioD: 0,
      };

      setDetalles(newDetail);
      asignarMontosEncabezado(newDetail);
      return;
    }

    const tasaCambio = Number(data?.TasaCambio || values?.TasaCambio || 1);
    const cantidad = Servicios
      ? Number(data?.CantidadReservada || 0)
      : Number(data?.Ingreso || 0);
    const precioL = Number(data?.Precio || 0);
    const precioD = tasaCambio > 0 ? precioL / tasaCambio : 0;
    const isvL = Number(data?.ISVProductoL || 0);
    const isv18L = Number(data?.ISV18ProductoL || 0);
    const descuentoL = Number(data?.Descuento || 0);

    const subTotalL = precioL * cantidad;
    const subTotalD = precioD * cantidad;
    const isvD = tasaCambio > 0 ? isvL / tasaCambio : 0;
    const isv18D = tasaCambio > 0 ? isv18L / tasaCambio : 0;
    const descuentoD = tasaCambio > 0 ? descuentoL / tasaCambio : 0;
    const montoL = subTotalL + isvL + isv18L - descuentoL;
    const montoD = subTotalD + isvD + isv18D - descuentoD;

    newDetail[index] = {
      ...newDetail[index],

      Precio: precioL,
      PrecioD: precioD,

      SubTotal: subTotalL,
      SubTotalD: subTotalD,

      ISVProductoL: isvL,
      ISVProductoD: isvD,

      ISV18ProductoL: isv18L,
      ISV18ProductoD: isv18D,

      Descuento: descuentoL,
      DescuentoD: descuentoD,

      MontoL: montoL,
      MontoD: montoD,

      CostoL: montoL - isvL - isv18L,
      CostoD: montoD - isvD - isv18D,

      TasaCambio: tasaCambio,
    };

    setDetalles(newDetail);
    asignarMontosEncabezado(newDetail);
  };

  // CAMBIAR PRECIO EN DOLARES
  const changePrecioD = ({ data }) => {
    const index = detalles.findIndex(
      (detail) => detail.IdIngresoDetalle === data.IdIngresoDetalle,
    );

    if (index === -1) {
      return;
    }

    const newDetail = [...detalles];

    if (!data.CodigoProducto) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Agregue el producto a ingresar.",
      );

      newDetail[index] = {
        ...newDetail[index],

        Precio: 0,
        PrecioD: 0,

        SubTotal: 0,
        SubTotalD: 0,

        MontoL: 0,
        MontoD: 0,

        CostoL: 0,
        CostoD: 0,
      };

      setDetalles(newDetail);
      asignarMontosEncabezado(newDetail);

      return;
    }

    const tasaCambio = Number(data?.TasaCambio || values?.TasaCambio || 1);

    if (tasaCambio <= 0) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Debe existir una tasa de cambio válida.",
      );

      return;
    }

    const cantidad = Servicios
      ? Number(data?.CantidadReservada || 0)
      : Number(data?.Ingreso || 0);

    /*
      El usuario modificó PrecioD.

      Por lo tanto PrecioD se convierte en
      nuestro valor base para esta operación.
    */
    const precioD = Number(data?.PrecioD || 0);
    const precioL = precioD * tasaCambio;

    /*
      Los impuestos y descuentos ya pertenecen
      al detalle.

      No los recalculamos desde cero porque
      cambiar el precio no significa cambiar
      el impuesto/descuento de la factura.
    */
    const isvL = Number(data?.ISVProductoL || 0);
    const isvD = Number(data?.ISVProductoD || 0);
    const isv18L = Number(data?.ISV18ProductoL || 0);
    const isv18D = Number(data?.ISV18ProductoD || 0);
    const descuentoL = Number(data?.Descuento || 0);
    const descuentoD = Number(data?.DescuentoD || 0);

    // SUBTOTALES
    const subTotalL = precioL * cantidad;

    const subTotalD = precioD * cantidad;

    // MONTOS
    const montoL = subTotalL + isvL + isv18L - descuentoL;

    const montoD = subTotalD + isvD + isv18D - descuentoD;

    newDetail[index] = {
      ...newDetail[index],

      Precio: precioL,
      PrecioD: precioD,

      SubTotal: subTotalL,
      SubTotalD: subTotalD,

      MontoL: montoL,
      MontoD: montoD,

      CostoL: montoL - isvL - isv18L,

      CostoD: montoD - isvD - isv18D,

      TasaCambio: tasaCambio,
    };

    setDetalles(newDetail);
    asignarMontosEncabezado(newDetail);
  };

  // CAMBIAR ISV EN DOLARES
  const changeISVD = ({ data }) => {
    const index = detalles.findIndex(
      (detail) => detail.IdIngresoDetalle === data.IdIngresoDetalle,
    );

    if (index === -1) {
      return;
    }

    const tasaCambio = Number(data?.TasaCambio || values?.TasaCambio || 0);

    if (tasaCambio <= 0) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Debe existir una tasa de cambio válida.",
      );

      return;
    }

    const nuevosDetalles = [...detalles];

    const cantidad = Servicios
      ? Number(data?.CantidadReservada || 0)
      : Number(data?.Ingreso || 0);

    const precioL = Number(data?.Precio || 0);

    const precioD = Number(data?.PrecioD || 0);

    // El valor que modificó el usuario
    const isvD = Number(data?.ISVProductoD || 0);

    // Conversión igual a IPS
    const isvL = isvD * tasaCambio;

    const isv18L = Number(data?.ISV18ProductoL || 0);

    const isv18D = Number(data?.ISV18ProductoD || 0);

    const descuentoL = Number(data?.Descuento || 0);

    const descuentoD = Number(data?.DescuentoD || 0);

    const subTotalL = precioL * cantidad;

    const subTotalD = precioD * cantidad;

    const montoL = subTotalL + isvL + isv18L - descuentoL;

    const montoD = subTotalD + isvD + isv18D - descuentoD;

    nuevosDetalles[index] = {
      ...nuevosDetalles[index],

      ISVProductoL: isvL,
      ISVProductoD: isvD,

      SubTotal: subTotalL,
      SubTotalD: subTotalD,

      MontoL: montoL,
      MontoD: montoD,

      CostoL: montoL - isvL - isv18L,

      CostoD: montoD - isvD - isv18D,

      TasaCambio: tasaCambio,
    };

    setDetalles(nuevosDetalles);
    asignarMontosEncabezado(nuevosDetalles);
  };

  // CAMBIAR MANUALMENTE MONTO / COSTO
  const changeMontoCosto = ({ data, column }) => {
    const index = detalles.findIndex(
      (detail) => detail.IdIngresoDetalle === data.IdIngresoDetalle,
    );

    if (index === -1) {
      return;
    }

    const field = column?.getColId?.() || column?.colId;

    if (!["MontoL", "MontoD", "CostoL", "CostoD"].includes(field)) {
      return;
    }

    const nuevosDetalles = [...detalles];

    /*
      COSTO L / COSTO D

      Los costos siguen siendo edición directa.
      No modificamos Precio, Monto ni SubTotal
      cuando Admin cambia manualmente un costo.
    */
    if (field === "CostoL" || field === "CostoD") {
      nuevosDetalles[index] = {
        ...nuevosDetalles[index],
        [field]: Number(data?.[field] || 0),
      };

      setDetalles(nuevosDetalles);
      asignarMontosEncabezado(nuevosDetalles);

      return;
    }

    const tasaCambio = Number(data?.TasaCambio || values?.TasaCambio || 0);
    if (tasaCambio <= 0) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Debe existir una tasa de cambio válida.",
      );
      return;
    }

    const cantidad = Number(data?.Ingreso || 0);
    if (cantidad <= 0) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "La cantidad de ingreso debe ser mayor a 0.",
      );

      return;
    }

    let montoL = Number(data?.MontoL || 0);
    let montoD = Number(data?.MontoD || 0);

    if (field === "MontoL") {
      montoL = Number(data?.MontoL || 0);
      montoD = montoL / tasaCambio;
    }
    if (field === "MontoD") {
      montoD = Number(data?.MontoD || 0);
      montoL = montoD * tasaCambio;
    }

    const precioL = cantidad > 0 ? montoL / cantidad : montoL;
    const precioD = cantidad > 0 ? montoD / cantidad : montoD;
    const subTotalL = precioL * cantidad;
    const subTotalD = precioD * cantidad;

    const isvL = Number(data?.ISVProductoL || 0);

    const isvD = Number(data?.ISVProductoD || 0);

    const isv18L = Number(data?.ISV18ProductoL || 0);

    const isv18D = Number(data?.ISV18ProductoD || 0);

    const costoL = montoL - isvL - isv18L;

    const costoD = montoD - isvD - isv18D;

    nuevosDetalles[index] = {
      ...nuevosDetalles[index],

      Precio: precioL,
      PrecioD: precioD,

      SubTotal: subTotalL,
      SubTotalD: subTotalD,

      MontoL: montoL,
      MontoD: montoD,

      CostoL: costoL,
      CostoD: costoD,

      TasaCambio: tasaCambio,
    };

    setDetalles(nuevosDetalles);
    asignarMontosEncabezado(nuevosDetalles);
  };

  // CAMBIAR DESCUENTO EN DOLARES
  const changeDescuentoD = ({ data }) => {
    const index = detalles.findIndex(
      (detail) => detail.IdIngresoDetalle === data.IdIngresoDetalle,
    );

    if (index === -1) {
      return;
    }

    const tasaCambio = Number(data?.TasaCambio || values?.TasaCambio || 0);

    if (tasaCambio <= 0) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Debe existir una tasa de cambio válida.",
      );

      return;
    }

    const nuevosDetalles = [...detalles];

    const cantidad = Servicios
      ? Number(data?.CantidadReservada || 0)
      : Number(data?.Ingreso || 0);

    const precioL = Number(data?.Precio || 0);

    const precioD = Number(data?.PrecioD || 0);

    const isvL = Number(data?.ISVProductoL || 0);

    const isvD = Number(data?.ISVProductoD || 0);

    const isv18L = Number(data?.ISV18ProductoL || 0);

    const isv18D = Number(data?.ISV18ProductoD || 0);

    // El usuario modificó el descuento en dólares
    const descuentoD = Number(data?.DescuentoD || 0);

    // Convertir el descuento a Lempiras
    const descuentoL = descuentoD * tasaCambio;

    const subTotalL = precioL * cantidad;

    const subTotalD = precioD * cantidad;

    const montoL = subTotalL + isvL + isv18L - descuentoL;

    const montoD = subTotalD + isvD + isv18D - descuentoD;

    nuevosDetalles[index] = {
      ...nuevosDetalles[index],

      Descuento: descuentoL,
      DescuentoD: descuentoD,

      SubTotal: subTotalL,
      SubTotalD: subTotalD,

      MontoL: montoL,
      MontoD: montoD,

      CostoL: montoL - isvL - isv18L,

      CostoD: montoD - isvD - isv18D,

      TasaCambio: tasaCambio,
    };
    setDetalles(nuevosDetalles);
    asignarMontosEncabezado(nuevosDetalles);
  };

  const changeBodega = ({ data }) => {
    return (
      <div>
        <Dropdown
          value={selectedBodega}
          options={bodegas}
          style={{ width: "203px" }}
          optionLabel="NombreBodega"
          filter
          filterBy="NombreBodega"
          onChange={(e) => {
            setSelectedBodega(e.value);
            if (selected.length > 0) {
              let detallesActualizados = detalles.map((detail) => {
                if (
                  selected.some(
                    (s) => s.IdIngresoDetalle === detail.IdIngresoDetalle,
                  )
                ) {
                  return {
                    ...detail,
                    IdBodega: e.value.IdBodega,
                    NombreBodega: e.value.NombreBodega,
                  };
                }
                return detail;
              });

              setDetalles(detallesActualizados);
              setSelected([]);
            } else {
              let tempo2 = [...detalles];
              const index = detalles.findIndex(
                (detail) => detail.IdIngresoDetalle === data.IdIngresoDetalle,
              );
              tempo2[index].IdBodega = e.value.IdBodega;
              tempo2[index].NombreBodega = e.value.NombreBodega;
              setDetalles(tempo2);
            }

            setResEst(true);
            setResPos(true);
            setResBand(true);
          }}
        />
      </div>
    );
  };

  const changeEstante = ({ data, oldValue, api }, column) => {
    return (
      <div>
        <Dropdown
          value={selectedEstante}
          options={filteredEstantes}
          style={{ width: "123px" }}
          optionLabel="NombreEstante"
          filter
          filterBy="NombreEstante"
          onChange={(e) => {
            setSelectedEstante(e.value);
            if (selected.length > 0) {
              let detallesActualizados = detalles.map((detail) => {
                if (
                  selected.some(
                    (s) => s.IdIngresoDetalle === detail.IdIngresoDetalle,
                  )
                ) {
                  return {
                    ...detail,
                    IdEstante: e.value.IdEstante,
                    NombreEstante: e.value.NombreEstante,
                  };
                }
                return detail;
              });

              setDetalles(detallesActualizados);
              setSelected([]);
            } else {
              let tempo2 = [...detalles];
              const index = detalles.findIndex(
                (detail) => detail.IdIngresoDetalle === data.IdIngresoDetalle,
              );
              tempo2[index].IdEstante = e.value.IdEstante;
              tempo2[index].NombreEstante = e.value.NombreEstante;
              setDetalles(tempo2);
            }
            setResEst(true);
            setResPos(true);
            setResBand(true);
          }}
        />
      </div>
    );
  };

  const changePosicion = ({ data, oldValue, api }, column) => {
    return (
      <div>
        <Dropdown
          value={selectedPosicion}
          options={filteredPosiciones}
          style={{ width: "123px" }}
          optionLabel="NombrePosicion"
          filter
          filterBy="NombrePosicion"
          onChange={(e) => {
            setSelectedPosicion(e.value);
            if (selected.length > 0) {
              let detallesActualizados = detalles.map((detail) => {
                if (
                  selected.some(
                    (s) => s.IdIngresoDetalle === detail.IdIngresoDetalle,
                  )
                ) {
                  return {
                    ...detail,
                    IdPosicion: e.value.IdPosicion,
                    NombrePosicion: e.value.NombrePosicion,
                  };
                }
                return detail;
              });

              setDetalles(detallesActualizados);
              setSelected([]);
            } else {
              let tempo2 = [...detalles];
              const index = detalles.findIndex(
                (detail) => detail.IdIngresoDetalle === data.IdIngresoDetalle,
              );
              tempo2[index].IdPosicion = e.value.IdPosicion;
              tempo2[index].NombrePosicion = e.value.NombrePosicion;
              setDetalles(tempo2);
            }
            setResEst(true);
            setResPos(true);
            setResBand(true);
          }}
        />
      </div>
    );
  };

  const changeBandeja = ({ data, oldValue, api }, column) => {
    return (
      <div>
        <Dropdown
          value={selectedBandeja}
          options={filteredBandejas}
          style={{ width: "123px" }}
          optionLabel="NombreBandeja"
          filter
          filterBy="NombreBandeja"
          // onChange={(e) => {
          //   setSelectedBandeja(e.value);
          //   let tempo2 = [...detalles];
          //   const index = detalles.findIndex(
          //     (detail) => detail.IdIngresoDetalle === data.IdIngresoDetalle
          //   );
          //   tempo2[index].IdBandeja = e.value?.IdBandeja;
          //   tempo2[index].NombreBandeja = e.value.NombreBandeja;
          //   setDetalles(tempo2);
          // }}
          onChange={(e) => {
            setSelectedBandeja(e.value);
            if (selected.length > 0) {
              let detallesActualizados = detalles.map((detail) => {
                if (
                  selected.some(
                    (s) => s.IdIngresoDetalle === detail.IdIngresoDetalle,
                  )
                ) {
                  return {
                    ...detail,
                    IdBandeja: e.value.IdBandeja,
                    NombreBandeja: e.value.NombreBandeja,
                  };
                }
                return detail;
              });

              setDetalles(detallesActualizados);
              setSelected([]);
            } else {
              let tempo2 = [...detalles];
              const index = detalles.findIndex(
                (detail) => detail.IdIngresoDetalle === data.IdIngresoDetalle,
              );
              tempo2[index].IdBandeja = e.value.IdBandeja;
              tempo2[index].NombreBandeja = e.value.NombreBandeja;
              setDetalles(tempo2);
            }
            setResEst(true);
            setResPos(true);
            setResBand(true);
          }}
        />
      </div>
    );
  };

  // CAMBIO DE LOTE
  const changeLote = ({ data }) => {
    return (
      <LotesOverlayPanel
        IdVendor={values?.CustomerName?.IdVendor || values?.IdVendor}
        rowData={data}
        onChange={({ api, data: loteSeleccionado }, rowData) => {
          const index = detalles.findIndex(
            (detail) => detail.IdIngresoDetalle === rowData.IdIngresoDetalle,
          );

          if (index === -1) {
            toastShow(
              toast,
              "error",
              "Error",
              "No se encontró el detalle que desea actualizar.",
            );
            return;
          }

          const loteYaAgregado = detalles.some(
            (detail) =>
              detail.IdLote === loteSeleccionado?.IdLote &&
              detail.IdIngresoDetalle !== rowData.IdIngresoDetalle,
          );

          if (loteYaAgregado) {
            toastShow(
              toast,
              "warn",
              "Advertencia",
              "El lote seleccionado ya existe en este ingreso.",
            );
            return;
          }

          const nuevosDetalles = [...detalles];

          nuevosDetalles[index] = {
            ...nuevosDetalles[index],
            IdLote: loteSeleccionado?.IdLote || null,
            NoLote: loteSeleccionado?.NoLote || "",
            NoLoteInt: loteSeleccionado?.NoLoteInt || "",
            CustomerName: loteSeleccionado?.CustomerName || "",
          };

          setDetalles(nuevosDetalles);

          api.stopEditing();
        }}
      />
    );
  };

  const changeNoSacos = ({ data, column }) => {
    const index = detalles.findIndex(
      (detail) => detail.IdIngresoDetalle === data.IdIngresoDetalle,
    );
    let newDetail = [...detalles];
    if (column.field === "NoSacos") {
      newDetail[index].NoSacos = data.NoSacos;
    }
    setDetalles(newDetail);
  };

  const abrirModalPacas = (rowData) => {
    if (!rowData?.IdIngresoDetalle || rowData.IdIngresoDetalle <= 0) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Debe guardar el ingreso de materia prima antes de importar las Pacas.",
      );
      return;
    }

    setDetallePacas(rowData);
    setShowModalPacas(true);
  };

  // CAMBIAR EXENTO LOCALMENTE
  const changeIsExtenso = (data, checked) => {
    let nuevosDetalles = [...detalles];

    if (selected?.length > 0) {
      const filasValidas = selected.filter(
        (detalle) =>
          Number(detalle?.ISVProductoL || 0) === 0 &&
          Number(detalle?.ISVProductoD || 0) === 0 &&
          Number(detalle?.ISV18ProductoL || 0) === 0 &&
          Number(detalle?.ISV18ProductoD || 0) === 0,
      );

      const idsValidos = new Set(
        filasValidas.map((detalle) => detalle.IdIngresoDetalle),
      );

      nuevosDetalles = nuevosDetalles.map((detalle) => {
        if (idsValidos.has(detalle.IdIngresoDetalle)) {
          return {
            ...detalle,
            IsExento: !Boolean(detalle?.IsExento),
          };
        }

        return detalle;
      });
    } else {
      nuevosDetalles = nuevosDetalles.map((detalle) => {
        if (detalle.IdIngresoDetalle === data?.IdIngresoDetalle) {
          return {
            ...detalle,
            IsExento: checked,
          };
        }

        return detalle;
      });
    }
    setDetalles(nuevosDetalles);
    const idCountryActual = Number(
      values?.CustomerName?.IdCountry ?? values?.IdCountry ?? 0,
    );
    if (idCountryActual === 95) {
      const todosExentos =
        nuevosDetalles.length > 0 &&
        nuevosDetalles.every(
          (detalle) =>
            detalle?.IsExento === true || Number(detalle?.IsExento) === 1,
        );

      setValues((prevValues) => {
        let nuevaOCE = String(prevValues?.OCE || "");

        if (todosExentos) {
          nuevaOCE = "";
        } else if (!nuevaOCE.trim()) {
          nuevaOCE = `OC${new Date().getFullYear()}`;
        }

        return {
          ...prevValues,
          OCE: nuevaOCE,
        };
      });
    }
    // Limpiar selección múltiple
    setSelected([]);
  };

  const columns = [
    {
      // ID DETALLE
      header: "ID",
      headerEn: "ID",
      field: "IdIngresoDetalle",
      frozen: true,
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      // FECHA INGRESO
      header: "Fecha Ingreso",
      headerEn: "Date Entry",
      field: "FechaIngreso",
      Format: "DateTime2",
      className: "small",
      frozen: true,
    },
    {
      // ESTADO
      header: "Estado",
      headerEn: "Status",
      field: "StatusName",
      frozen: true,
      className: "medium",
      Format: "Estado",
      body: (rowData) => ({
        ID: rowData?.IdEstado,
        Estado: rowData?.StatusName,
      }),
    },
    {
      // No. ORDEN
      header: "No. Orden",
      headerEn: "No. Order",
      field: "PurchaseOrder",
      frozen: true,
      className: " small",
      editable: (data) => {
        if (habilitar) {
          if (
            data.data.Inventario < data.data.Ingreso &&
            data.data?.IdIngresoDetalle > 0
          ) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      },
      cellEditor: changePO,
      Format: "Modal",
      onCellDoubleClicked: ({ data }) => {
        if (data?.PurchaseOrder) {
          setPoParaAbrir(data.PurchaseOrder);
        }
      },
      hidden: showPOColumn,
    },
    {
      // CODIGO
      header: "Código",
      headerEn: "Code",
      field: "CodigoProducto",
      className: "Xsmall",
    },
    {
      // PRODUCTO
      header: "Producto",
      headerEn: "Product",
      cellEditor: changeProducto,
      editable: (data) => {
        if (!showPOColumn && habilitar) {
          if (
            data.data.Inventario < data.data.Ingreso &&
            data.data?.IdIngresoDetalle > 0
          ) {
            return false;
          } else {
            return true;
          }
        }
        return false;
      },
      field: "NombreProducto",
      className: "XXlarge",
    },
    {
      // DESCRIPCION
      header: "Descripción",
      headerEn: "Description",
      field: "Descripcion",
    },
    {
      // TIPO PRODUCTO
      header: "Tipo Producto",
      headerEn: "Product Type",
      field: "NombreCategoria",
      className: "small",
    },
    {
      // CATEGORIA
      header: "Categoría",
      headerEn: "Category",
      field: "NombreSubcategoria",
      className: "small",
    },
    {
      // SUB CATEGORIA
      header: "Sub Categoría",
      headerEn: "SubCategory",
      field: "NombreTipoProducto",
      className: "medium",
    },
    {
      // UNIDAD
      header: "Unidad",
      headerEn: "Unit",
      field: "UnitName",
      className: "medium",
    },
    {
      // NOMBRE BODEGA
      field: "NombreBodega",
      header: "Bodega",
      headerEn: "Warehouse",
      className: "large",
      hidden: MateriaPrima === true,
      body: (rowData) => rowData.NombreBodega,
      cellEditor: changeBodega,
      editable: (data) => {
        if (habilitar) {
          if (
            data.data.Inventario < data.data.Ingreso &&
            data.data?.IdIngresoDetalle > 0
          ) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      },
    },
    {
      // NOMBRE ESTANTE
      field: "NombreEstante",
      header: "Estante",
      className: "small",
      hidden: MateriaPrima === true,
      body: (rowData) => rowData.NombreEstante,
      cellEditor: changeEstante,
      // editable: habilitar,
      editable: (data) => {
        if (habilitar) {
          if (
            data.data.Inventario < data.data.Ingreso &&
            data.data?.IdIngresoDetalle > 0
          ) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      },
    },
    {
      // NOMBRE POSICION
      field: "NombrePosicion",
      header: "Fila",
      className: "small",
      hidden: MateriaPrima === true,
      body: (rowData) => rowData.NombrePosicion,
      cellEditor: changePosicion,
      // editable: habilitar,
      editable: (data) => {
        if (habilitar) {
          if (
            data.data.Inventario < data.data.Ingreso &&
            data.data?.IdIngresoDetalle > 0
          ) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      },
    },
    {
      // NOMBRE BANDEJA
      field: "NombreBandeja",
      header: "Bandeja",
      className: "small",
      hidden: MateriaPrima === true,
      body: (rowData) => rowData.NombreBandeja,
      cellEditor: changeBandeja,
      editable: (data) => {
        if (habilitar) {
          if (
            data.data.Inventario < data.data.Ingreso &&
            data.data?.IdIngresoDetalle > 0
          ) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      },
    },
    {
      // SOLICITA
      header: "Solicitado",
      headerEn: "Type",
      Sumary: "sum",
      field: "Quantity",
      Format: "Currency",
      className: "Xsmall",
      hidden: showPOColumn,
    },
    {
      // INGRESADO
      header: "Ingresado",
      headerEn: "Ingresado",
      field: "QtyReceive",
      Sumary: "sum",
      Format: "Currency",
      className: "Xsmall",
    },
    //----------- SERVICIO ----------
    Servicios
      ? {
          header: "Balance PO",
          headerEn: "Balance PO",
          field: "BalanceReservado",
          Sumary: "sum",
          Format: "Currency",
          frozen: true,
          className: "Xsmall",
          hidden: showPOColumn,
        }
      : {
          header: "Balance PO",
          headerEn: "Balance PO",
          field: "Balance",
          Sumary: "sum",
          Format: "Currency",
          frozen: true,
          className: "Xsmall",
          hidden: showPOColumn,
        },
    {
      // ES EXENTO
      field: "IsExento",
      header: "Exento",
      className: "XXsmall",
      width: 65,
      minWidth: 65,
      maxWidth: 65,
      Format: "Template",
      align: "center",
      frozen: "true",
      alignFrozen: "right",
      filter: false,
      body: (rowData) =>
        rowData?.IdIngresoDetalle && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Checkbox
              onChange={(e) => {
                changeIsExtenso(rowData, e.checked);
              }}
              disabled={
                !habilitar ||
                !!rowData?.ISVProductoL ||
                !!rowData?.ISV18ProductoL
              }
              checked={rowData.IsExento}
            />
          </div>
        ),
    },
    Servicios
      ? {
          header: "Ingreso",
          headerEn: "Income",
          field: "CantidadReservada",
          editable: (data) => {
            if (habilitar) {
              if (
                data.data.BalanceReservado === data.data.CantidadReservada &&
                data.data.IdIngresoDetalle > 0
              ) {
                return false;
              } else {
                return true;
              }
            }
          },
          onChange: (data) => changeIngreso(data),
          Sumary: "sum",
          Format: "Currency",
          frozen: true,
          alignFrozen: "right",
          className: "Xsmall",
        }
      : {
          // INGRESO / PESO NETO PARA MATERIA PRIMA
          header: esMateriaPrimaIngreso ? "Ingreso Neto" : "Ingreso",
          headerEn: esMateriaPrimaIngreso ? "Net Weight Lbs" : "Income",
          field: "Ingreso",
          editable: esMateriaPrimaIngreso ? false : habilitar,
          onChange: (data) => changeIngreso(data),
          Sumary: "sum",
          Format: "Currency",
          frozen: true,
          alignFrozen: "right",
          className: "Xsmall",
          width: esMateriaPrimaIngreso ? 100 : undefined,
          minWidth: esMateriaPrimaIngreso ? 100 : undefined,
        },
    // INGRESO EN CANTIDAD DE PACAS
    ...(esMateriaPrimaIngreso
        ? [
            {
              header: "Ingreso Pacas",
              headerEn: "Bales In",
              field: "IngresoPacas",
              Sumary: "sum",
              Format: "Right",
              frozen: true,
              alignFrozen: "right",
              className: "Xsmall",
              editable: false,
              width: 99,
              minWidth: 99,
            },
          ]
        : []),
      
    // BOTÓN PARA IMPORTAR / VER PACAS
    ...(esMateriaPrimaIngreso
      ? [
          {
            header: "Pacas",
            headerEn: "",
            field: "Pacas",
            Format: "Template",
            className: "XXsmall",
            width: 65,
            minWidth: 65,
            maxWidth: 65,
            frozen: true,
            alignFrozen: "right",
            filter: false,
            body: (rowData) => (
              <div className="d-flex justify-content-center align-items-center">
                <Button
                  icon="pi pi-file-excel"
                  className="p-button-text p-button-success"
                  tooltip="Importar Pacas"
                  tooltipOptions={{
                    position: "top",
                  }}
                  disabled={
                    !rowData?.IdIngresoDetalle ||
                    rowData.IdIngresoDetalle <= 0
                  }
                  onClick={() => abrirModalPacas(rowData)}
                />
              </div>
            ),
          },
        ]
      : []),
    //-------------------------------
    {
      // INVENTARIO
      header: "Inventario",
      headerEn: "Inventory",
      Sumary: "sum",
      field: "Inventario",
      hidden: userAuth.IdRol === 1,
      Format: "Currency",
      className: "Xsmall",
    },
    {
      // MONEDA
      header: "Moneda",
      headerEn: "Currency",
      field: "Currency",
      className: "Xsmall",
    },
    ...(esMateriaPrimaIngreso
      ? [
          {
            // No. LOTE
            field: "NoLote",
            header: "Lote",
            headerEn: "Lot",
            className: "medium",
            editable: habilitar,
            cellEditor: changeLote,
          },
        ]
      : []
    ),
    {
      // No. SACOS
      header: "No. Sacos",
      headerEn: "No. Sacos",
      field: "NoSacos",
      Format: "Currency",
      onChange: (data) => changeNoSacos(data),
      editable: habilitar,
      hidden: isMateriaPrima,
      className: "medium",
    },
    {
      // No. LOTE INTERNO
      header: "No. Lote Interno",
      headerEn: "No. Lote Interno",
      field: "NoLoteInt",
      hidden: userAuth.IdRol === 1 && isMateriaPrima,
      className: "medium",
    },
    {
      // FECHA OBSOLETO
      header: "Fecha Obsoleto",
      headerEn: "Date Obsolete",
      field: "FechaObsoleto",
      className: "large",
      hidden: !isMateriaPrima,
      editable: habilitar,
      align: "center",
      Format: "DateDisabled",
    },
    {
      // TASA DE CAMBIO
      field: "TasaCambio",
      header: "Tasa Cambio",
      headerEn: "Exchange Rate",
      Format: "Decimal",
      Sumary: "sum",
      className: "Xsmall",
    },
    // ---------- EMBALAJES ----------
    {
      headerName: "Embalaje",
      children: [
        {
          field: "EmbalajeL",
          header: "Monto L",
          Sumary: "sum",
          headerEn: "Monto L",
          hidden: verCostos || verCostosBodega,
          Format: "Currency",
          className: "small",
        },
        {
          field: "EmbalajeD",
          header: "Monto $",
          Sumary: "sum",
          headerEn: "Monto $",
          hidden: verCostos || verCostosBodega,
          Format: "Currency",
          className: "small",
        },
      ],
    },
    // ---------- DESADUANAJE ----------
    {
      headerName: "Desaduanaje",
      children: [
        {
          field: "DesaduanajeL",
          header: "Monto L",
          Sumary: "sum",
          hidden: verCostos || verCostosBodega,
          headerEn: "Monto L",
          Format: "Currency",
          className: "small",
        },
        {
          field: "DesaduanajeD",
          header: "Monto $",
          Sumary: "sum",
          hidden: verCostos || verCostosBodega,
          headerEn: "Monto $",
          Format: "Currency",
          className: "small",
        },
      ],
    },
    // ---------- FLETES ----------
    {
      headerName: "Flete",
      children: [
        {
          field: "FleteL",
          header: "Monto L",
          Sumary: "sum",
          hidden: verCostos || verCostosBodega,
          headerEn: "Monto L",
          Format: "Currency",
          className: "small",
        },
        {
          field: "FleteD",
          header: "Monto $",
          Sumary: "sum",
          hidden: verCostos || verCostosBodega,
          headerEn: "Monto $",
          Format: "Currency",
          className: "small",
        },
      ],
    },
    // ---------- OTROS COSTOS ----------
    {
      headerName: "Otros Costos",
      children: [
        {
          field: "OtrosCostosL",
          header: "Monto L",
          Sumary: "sum",
          hidden: verCostos || verCostosBodega,
          headerEn: "Monto L",
          Format: "Currency",
          className: "small",
        },
        {
          field: "OtrosCostosD",
          header: "Monto $",
          Sumary: "sum",
          hidden: verCostos || verCostosBodega,
          headerEn: "Monto $",
          Format: "Currency",
          className: "small",
        },
      ],
    },
    // ---------- LEMPIRAS ----------
    {
      headerName: "Lempiras",
      children: [
        {
          header: "PrecioL",
          headerEn: "PriceL",
          field: "Precio",
          hidden: hiddenPriceColumn,
          Format: "Currency",
          onChange: (data) => changePrecio(data),
          className: "Xsmall",
          editable: (data) => {
            // El ingreso debe estar en modo edición.
            if (!habilitar) {
              return false;
            }

            // Si ya existe una salida asociada a este ingreso,
            // conservamos la protección propia.
            if (
              data.data.Inventario < data.data.Ingreso &&
              data.data?.IdIngresoDetalle > 0
            ) {
              return false;
            }

            // ADMIN:
            // puede modificar el precio tanto CON PO como SIN PO.
            if (Number(userAuth?.IdRol) === 1) {
              return true;
            }

            // OTROS USUARIOS:
            // solamente pueden modificarlo en modo SIN PO
            // y cuando el detalle no pertenece a una PO.
            if (!showPOColumn && !data.data?.IdPurchaseOrderDetail) {
              return true;
            }

            return false;
          },
        },
        {
          header: "Sub Total L",
          hidden: hiddenPriceColumn,
          headerEn: "Sub Total L",
          Sumary: "sum",
          onChange: (data) => changePrecio(data),
          field: "SubTotal",
          Format: "Currency",
          className: "Xsmall",
        },
        {
          header: "ISV L",
          Sumary: "sum",
          hidden: hiddenPriceColumn,
          headerEn: "TAX L",
          field: "ISVProductoL",
          Format: "Currency",
          onChange: (data) => changePrecio(data),
          className: "Xsmall",
          editable: (data) => {
            // Solo SIN PO y en modo edición
            if (showPOColumn || !habilitar) {
              return false;
            }
            // Si es exento no debe poder llevar ISV
            if (
              data.data?.IsExento === true ||
              Number(data.data?.IsExento) === 1
            ) {
              return false;
            }
            // no modificar si ya existen movimientos
            if (
              data.data.Inventario < data.data.Ingreso &&
              data.data?.IdIngresoDetalle > 0
            ) {
              return false;
            }
            return true;
          },
        },
        {
          header: "ISV 18 L",
          Sumary: "sum",
          hidden: hiddenPriceColumn,
          headerEn: "TAX 18 L",
          field: "ISV18ProductoL",
          Format: "Currency",
          onChange: (data) => changePrecio(data),
          className: "Xsmall",
          editable: false,
        },
        {
          header: "Desc. L",
          hidden: hiddenPriceColumn,
          headerEn: "Disc. L",
          editable: (data) => {
            if (!showPOColumn && habilitar) {
              if (
                data.data.Inventario < data.data.Ingreso &&
                data.data?.IdIngresoDetalle > 0
              ) {
                return false;
              } else {
                return true;
              }
            }
            return false;
          },
          field: "Descuento",
          onChange: (data) => changePrecio(data),
          Sumary: "sum",
          Format: "Currency",
          className: "Xsmall",
        },
        {
          header: "MontoL",
          hidden: hiddenPriceColumn,
          headerEn: "MontoL",
          field: "MontoL",
          Format: "Currency",
          Sumary: "sum",
          className: "small",
          editable: habilitar,
          onChange: (data) => changeMontoCosto(data),
        },
      ],
    },
    {
      // COSTO LEMPIRAS
      header: "CostoL",
      headerEn: "CostoL",
      // hidden: hiddenPriceColumn,
      hidden: Number(userAuth?.IdRol) === 1 ? undefined : true,
      field: "CostoL",
      Format: "Currency",
      Sumary: "sum",
      frozen: true,
      alignFrozen: "right",
      className: "small",
      editable: habilitar && Number(userAuth?.IdRol) === 1,
      onChange: (data) => changeMontoCosto(data),
    },
    // ---------- DOLARES ----------
    {
      headerName: "Dolares",
      children: [
        {
          // PRECIO UNITARIO DOLARES
          header: "Precio $",
          headerEn: "Price $",
          field: "PrecioD",
          hidden: hiddenPriceColumn,
          Format: "Currency",
          className: "Xsmall",
          editable: (data) => {
            // Primero tiene que estar editando.
            if (!habilitar) {
              return false;
            }
            /*
              si ya existen movimientos de inventario,
              no permitimos cambiar el precio.
            */
            if (
              data.data.Inventario < data.data.Ingreso &&
              data.data?.IdIngresoDetalle > 0
            ) {
              return false;
            }
            // ADMIN puede editar CON PO y SIN PO.
            if (Number(userAuth?.IdRol) === 1) {
              return true;
            }
            /*
              Otros usuarios:
              solamente en ingreso SIN PO
              y detalle que realmente no venga de PO.
            */
            if (!showPOColumn && !data.data?.IdPurchaseOrderDetail) {
              return true;
            }
            return false;
          },
          onChange: (data) => changePrecioD(data),
        },
        {
          header: "Sub Total $",
          headerEn: "Sub Total $",
          Sumary: "sum",
          hidden: hiddenPriceColumn,
          onChange: (data) => changePrecio(data),
          field: "SubTotalD",
          Format: "Currency",
          className: "Xsmall",
        },
        {
          header: "ISV $",
          hidden: hiddenPriceColumn,
          headerEn: "TAX $",
          Sumary: "sum",
          field: "ISVProductoD",
          Format: "Currency",
          className: "Xsmall",

          editable: (data) => {
            // Solo SIN PO y editando
            if (showPOColumn || !habilitar) {
              return false;
            }
            // Un producto exento no puede llevar ISV
            if (
              data.data?.IsExento === true ||
              Number(data.data?.IsExento) === 1
            ) {
              return false;
            }
            // Protección propia
            if (
              data.data.Inventario < data.data.Ingreso &&
              data.data?.IdIngresoDetalle > 0
            ) {
              return false;
            }

            return true;
          },
          onChange: (data) => changeISVD(data),
        },
        {
          header: "ISV 18% $",
          hidden: hiddenPriceColumn,
          headerEn: "TAX 18% $",
          Sumary: "sum",
          field: "ISV18ProductoD",
          Format: "Currency",
          className: "Xsmall",
        },
        {
          // DESCUENTO DOLARES
          header: "Desc. $",
          headerEn: "Disc. $",
          field: "DescuentoD",
          hidden: hiddenPriceColumn,
          Sumary: "sum",
          Format: "Currency",
          className: "Xsmall",

          editable: (data) => {
            // descuento solamente editable en registro manual.
            // En registro manual = SIN PO.
            if (showPOColumn || !habilitar) {
              return false;
            }
            // Conservamos la protección propia de CSM
            if (
              data.data.Inventario < data.data.Ingreso &&
              data.data?.IdIngresoDetalle > 0
            ) {
              return false;
            }

            return true;
          },
          onChange: (data) => changeDescuentoD(data),
        },
        {
          // MONTO DOLARES
          header: "Monto $",
          headerEn: "Monto $",
          hidden: hiddenPriceColumn,
          field: "MontoD",
          Format: "Currency",
          Sumary: "sum",
          className: "small",
          editable: habilitar,
          onChange: (data) => changeMontoCosto(data),
        },
      ],
    },
    {
      // COSTO DOLARES
      header: "Costo $",
      headerEn: "Costo $",
      // hidden: hiddenPriceColumn,
      hidden: Number(userAuth?.IdRol) === 1 ? undefined : true,
      field: "CostoD",
      Format: "Currency",
      Sumary: "sum",
      frozen: true,
      alignFrozen: "right",
      className: "small",
      editable: habilitar && Number(userAuth?.IdRol) === 1,
      onChange: (data) => changeMontoCosto(data),
    },
    {
      // PRECIO UNITARIO LEMPIRAS
      header: "PrecioUL",
      Sumary: "sum",
      headerEn: "PriceUL",
      field: "PrecioUL",
      hidden: hiddenPriceColumn,
      Format: "Currency",
      className: "Xsmall",
    },
    {
      // PRECIO UNITARIO DOLARES
      header: "PrecioUD",
      Sumary: "sum",
      headerEn: "PriceUD",
      field: "PrecioUD",
      hidden: hiddenPriceColumn,
      Format: "Currency",
      className: "Xsmall",
    },
  ];

  const table = {
    Columns: columns.filter((column) => column.hidden !== true),
    Data: detalles,
    selected: selected,
    setSelected: setSelected,
  };

  // FUNCION PARA CAMBIAR LOS VALORES DE LOS DETALLES CUANDO SE MODIFICA LA TASA DE CAMBIO
  const cambiarValores = () => {
    if (detalles.length === 0) {
      return;
    }

    const tasaCambio = Number(values?.TasaCambio || 0);

    if (!tasaCambio || tasaCambio <= 0) {
      return;
    }

    const newDetails = detalles.map((detail) => {
      const cantidad = Servicios
        ? Number(detail?.CantidadReservada || 0)
        : Number(detail?.Ingreso || 0);
      const idCurrency = Number(detail?.IdCurrency);
      let precioL = Number(detail?.Precio || 0);
      let precioD = Number(detail?.PrecioD || 0);

      if (idCurrency === 1) {
        precioL = precioD * tasaCambio;
      } else {
        precioD = precioL / tasaCambio;
      }

      const isvProducto = Number(detail?.ISVProducto || 0);
      const isv18Producto = Number(detail?.ISV18Producto || 0);
      const descuentoProducto = Number(detail?.DescuentoProducto || 0);

      // SUBTOTALES
      const subTotalL = precioL * cantidad;
      const subTotalD = precioD * cantidad;

      // ISV 15%
      const isvProductoL =
        idCurrency === 1
          ? isvProducto * tasaCambio * cantidad
          : isvProducto * cantidad;
      const isvProductoD =
        idCurrency === 1
          ? isvProducto * cantidad
          : (isvProducto / tasaCambio) * cantidad;

      // ISV 18%
      const isv18ProductoL =
        idCurrency === 1
          ? isv18Producto * tasaCambio * cantidad
          : isv18Producto * cantidad;
      const isv18ProductoD =
        idCurrency === 1
          ? isv18Producto * cantidad
          : (isv18Producto / tasaCambio) * cantidad;

      // DESCUENTO
      const descuentoL =
        idCurrency === 1
          ? descuentoProducto * tasaCambio * cantidad
          : descuentoProducto * cantidad;
      const descuentoD =
        idCurrency === 1
          ? descuentoProducto * cantidad
          : (descuentoProducto / tasaCambio) * cantidad;

      // MONTOS
      const montoL = subTotalL + isvProductoL + isv18ProductoL - descuentoL;
      const montoD = subTotalD + isvProductoD + isv18ProductoD - descuentoD;

      return {
        ...detail,

        Precio: precioL,
        PrecioD: precioD,

        SubTotal: subTotalL,
        SubTotalD: subTotalD,

        ISVProductoL: isvProductoL,
        ISVProductoD: isvProductoD,

        ISV18ProductoL: isv18ProductoL,
        ISV18ProductoD: isv18ProductoD,

        Descuento: descuentoL,
        DescuentoD: descuentoD,

        MontoL: montoL,
        MontoD: montoD,

        CostoL: montoL - isvProductoL - isv18ProductoL,
        CostoD: montoD - isvProductoD - isv18ProductoD,

        TasaCambio: tasaCambio,
      };
    });

    setDetalles(newDetails);
    asignarMontosEncabezado(newDetails);
  };

  useEffect(() => {
    getInfo();
    setDetalles([]);
    if (idIngreso) {
      obtenerIngreso();
    } else {
      getInfoNew();
    }
  }, [idIngreso]);

  useEffect(() => {
    if (selectedBodega) {
      const filteredEstantes = estantes.filter(
        (e) => e.IdBodega === selectedBodega.IdBodega,
      );
      setFilteredEstantes(filteredEstantes);
      setSelectedEstante(null);
      setSelectedPosicion(null);
      setFilteredPosiciones([]);
      setFilteredBandejas([]);
    } else {
      setFilteredEstantes(estantes);
    }
  }, [selectedBodega]);

  useEffect(() => {
    if (selectedEstante) {
      const filteredPosiciones = posicion.filter(
        (p) => p.IdEstante === selectedEstante.IdEstante,
      );
      setFilteredPosiciones(filteredPosiciones);
      setSelectedPosicion(null);
      setFilteredBandejas([]);
    } else {
      setFilteredPosiciones(posicion);
    }
  }, [selectedEstante]);

  useEffect(() => {
    if (selectedPosicion) {
      const filteredBandejas = bandeja.filter(
        (b) => b.IdPosicion === selectedPosicion.IdPosicion,
      );
      setFilteredBandejas(filteredBandejas);
    } else {
      setFilteredBandejas(bandeja);
    }
  }, [selectedPosicion]);

  useEffect(() => {
    if (selectedBodega) {
      const updatedDetalles = [...detalles].map((detail) => {
        const index = detalles.findIndex(
          (d) => d.IdIngresoDetalle === detail.IdIngresoDetalle,
        );
        if (
          index !== -1 &&
          detalles[index].IdBodega === selectedBodega.IdBodega
        ) {
          if (resEst) {
            let updatedDetail = { ...detalles[index] };
            updatedDetail.IdEstante = null;
            updatedDetail.NombreEstante = "";
            updatedDetail.IdPosicion = null;
            updatedDetail.NombrePosicion = "";
            updatedDetail.IdBandeja = null;
            updatedDetail.NombreBandeja = "";
            return updatedDetail;
          }
        }
        return detail;
      });
      setDetalles(updatedDetalles);
    }
  }, [selectedBodega]);

  useEffect(() => {
    if (selectedEstante) {
      const updatedDetalles = [...detalles].map((detail) => {
        const index = detalles.findIndex(
          (d) => d.IdIngresoDetalle === detail.IdIngresoDetalle,
        );
        if (
          index !== -1 &&
          detalles[index].IdEstante === selectedEstante.IdEstante
        ) {
          if (resPos) {
            let updatedDetail = { ...detalles[index] };
            updatedDetail.IdPosicion = null;
            updatedDetail.NombrePosicion = "";
            updatedDetail.IdBandeja = null;
            updatedDetail.NombreBandeja = "";
            return updatedDetail;
          }
        }
        return detail;
      });
      setDetalles(updatedDetalles);
    }
  }, [selectedEstante, resPos]);

  useEffect(() => {
    if (selectedPosicion) {
      const updatedDetalles = [...detalles].map((detail) => {
        const index = detalles.findIndex(
          (d) => d.IdIngresoDetalle === detail.IdIngresoDetalle,
        );
        if (
          index !== -1 &&
          detalles[index].IdPosicion === selectedPosicion.IdPosicion
        ) {
          if (resBand) {
            let updatedDetail = { ...detalles[index] };
            updatedDetail.IdBandeja = null;
            updatedDetail.NombreBandeja = "";
            return updatedDetail;
          }
        }
        return detail;
      });
      setDetalles(updatedDetalles);
    }
  }, [selectedPosicion, resBand]);

  useEffect(() => {
    cambiarValores();
  }, [values?.TasaCambio]);

  return (
    <div>
      <Loader loading={loading} />
      <Toast ref={toast} />
      <EncabezadoIngresos
        formulario={{
          values,
          setValues,
          handleInputChange,
          resetForm,
        }}
        datos={{
          detalles,
          proveedor,
          term,
          monedas,
          tiposIngreso,
          listEstados,
          cuentas,
        }}
        estado={{
          habilitar,
          setHabilitar,
          showPOColumn,
          setShowPOColumn,
          hab,
          setHab,
          setCheckDollar,
          verCostosBodega,
          setVerCostosBodega,
          isMateriaPrima,
          ingresoSinOC,
          poParaAbrir,
          setPoParaAbrir,
          selected,
          setSelected,
        }}
        acciones={{
          obtenerIngreso,
          getInfo,
          actualizarIngresosScreenListado,
          guardarIngresos,
          guardarIngresosBodega,
          agregarNuevaFila,
          eliminarItemDetalle,
          eliminarIngresoCompleto,
          addOC,
          addSingleOC,
          getInfoNew,
          setDetalles,
          setIngresoToShow,
          setLoading,
        }}
        MateriaPrima={MateriaPrima}
        Servicios={Servicios}
        editable={editable}
      />

      <Card
        contenido={
          <div style={{ height: "56vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />

      <div className="mt-2" style={{ textAlign: "right", marginRight: 10 }}>
        <p style={{ marginBottom: "1px", fontSize: 14 }}>
          <strong>Usuario Creación:</strong>{" "}
          {values?.UserNameIngreso
            ? values?.UserNameIngreso
            : userAuth?.UserName}
        </p>
        <p style={{ marginBottom: "1px", fontSize: 14 }}>
          <strong>Fecha Creación:</strong>{" "}
          {values?.FechaIngreso
            ? new Date(values.FechaIngreso).toLocaleDateString()
            : ""}
        </p>
        {values?.UserNameEdit && (
          <p style={{ marginBottom: "1px", fontSize: 14 }}>
            <strong>Usuario Edición:</strong> {values?.UserNameEdit}
          </p>
        )}
        {values?.FechaEdit && (
          <p style={{ marginBottom: "1px", fontSize: 14 }}>
            <strong>Fecha Edición:</strong> {values?.FechaEdit}
          </p>
        )}
      </div>

     <ModalArchivoPacas
        visible={showModalPacas}
        onHide={async () => {
          setShowModalPacas(false);
          setDetallePacas(null);

          if (values?.NumeroIngreso) {
            await obtenerIngreso();
          }
        }}
        detalleIngreso={detallePacas}
        proveedor={
          typeof values?.CustomerName === "object"
            ? values?.CustomerName?.CustomerName
            : values?.CustomerName
        }
        NoIngreso={values?.NumeroIngreso}
        Factura={values?.Factura}
        FechaFactura={values?.FechaFactura}
      />
    </div>
  );
};

export default IngresosBodegaCrud;
